// English translations for React Admin (using default messages from react-admin)

const englishMessages = {
    ra: {
        action: {
            add_filter: 'Add filter',
            add: 'Add',
            back: 'Go Back',
            bulk_actions: '%{smart_count} selected',
            cancel: 'Cancel',
            clear_array_input: 'Clear the list',
            clear_input_value: 'Clear value',
            clone: 'Clone',
            confirm: 'Confirm',
            create: 'Create',
            create_item: 'Create %{item}',
            delete: 'Delete',
            edit: 'Edit',
            export: 'Export',
            list: 'List',
            refresh: 'Refresh',
            remove_filter: 'Remove this filter',
            remove_all_filters: 'Remove all filters',
            remove: 'Remove',
            save: 'Save',
            search: 'Search',
            select_all: 'Select all',
            select_row: 'Select this row',
            show: 'Show',
            sort: 'Sort',
            undo: 'Undo',
            unselect: 'Unselect',
            expand: 'Expand',
            close: 'Close',
            open_menu: 'Open menu',
            close_menu: 'Close menu',
            update: 'Update',
            move_up: 'Move up',
            move_down: 'Move down',
            open: 'Open',
            toggle_theme: 'Toggle Theme',
            select_columns: 'Columns',
            reset: 'Reset',
            search_columns: 'Search columns',
            select_all_button: 'Select all',
            update_application: 'Reload Application',
        },
        boolean: {
            true: 'Yes',
            false: 'No',
            null: ' ',
        },
        page: {
            create: 'Create %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Something went wrong',
            list: '%{name}',
            loading: 'Loading',
            not_found: 'Not Found',
            show: '%{name} #%{id}',
            empty: 'No %{name} yet.',
            invite: 'Do you want to add one?',
        },
        input: {
            file: {
                upload_several: 'Drop some files to upload, or click to select one.',
                upload_single: 'Drop a file to upload, or click to select it.',
            },
            image: {
                upload_several: 'Drop some pictures to upload, or click to select one.',
                upload_single: 'Drop a picture to upload, or click to select it.',
            },
            references: {
                all_missing: 'Unable to find references data.',
                many_missing: 'At least one of the associated references no longer appears to be available.',
                single_missing: 'Associated reference no longer appears to be available.',
            },
            password: {
                toggle_visible: 'Hide password',
                toggle_hidden: 'Show password',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Are you sure?',
            bulk_delete_content: 'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
            bulk_update_content: 'Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?',
            bulk_update_title: 'Update %{name} |||| Update %{smart_count} %{name}',
            delete_content: 'Are you sure you want to delete this item?',
            delete_title: 'Delete %{name} #%{id}',
            details: 'Details',
            error: 'A client error occurred and your request could not be completed.',
            invalid_form: 'The form is not valid. Please check for errors',
            loading: 'The page is loading, just a moment please',
            no: 'No',
            not_found: 'Either you typed a wrong URL, or you followed a bad link.',
            yes: 'Yes',
            unsaved_changes: "Some of your changes weren't saved. Are you sure you want to ignore them?",
        },
        navigation: {
            no_results: 'No results found',
            no_more_results: 'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}',
            current_page: 'Page %{page}',
            page: 'Go to page %{page}',
            first: 'Go to first page',
            last: 'Go to last page',
            next: 'Next',
            previous: 'Previous',
            page_rows_per_page: 'Rows per page:',
            skip_nav: 'Skip to content',
        },
        sort: {
            sort_by: 'Sort by %{field} %{order}',
            ASC: 'ascending',
            DESC: 'descending',
        },
        auth: {
            auth_check_error: 'Please login to continue',
            user_menu: 'Profile',
            username: 'Username',
            password: 'Password',
            sign_in: 'Sign in',
            sign_in_error: 'Authentication failed, please retry',
            logout: 'Logout',
        },
        notification: {
            updated: 'Element updated |||| %{smart_count} elements updated',
            created: 'Element created',
            deleted: 'Element deleted |||| %{smart_count} elements deleted',
            bad_item: 'Incorrect element',
            item_doesnt_exist: 'Element does not exist',
            http_error: 'Server communication error',
            data_provider_error: 'dataProvider error. Check the console for details.',
            i18n_error: 'Cannot load the translations for the specified language',
            canceled: 'Action cancelled',
            logged_out: 'Your session has ended, please reconnect.',
        },
        validation: {
            required: 'Required',
            minLength: 'Must be %{min} characters at least',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Saved queries',
            query_name: 'Query name',
            new_label: 'Save current query...',
            new_dialog_title: 'Save current query as',
            remove_label: 'Remove saved query',
            remove_label_with_name: 'Remove query "%{name}"',
            remove_dialog_title: 'Remove saved query?',
            remove_message: 'Are you sure you want to remove that item from your list of saved queries?',
            help: 'Filter the list and save this query for later',
        },
        configurable: {
            customize: 'Customize',
            configureMode: 'Configure this page',
            inspector: {
                title: 'Inspector',
                content: 'Hover the application UI elements to configure them',
                reset: 'Reset Settings',
                hideAll: 'Hide All',
                showAll: 'Show All',
            },
            Datagrid: {
                title: 'Datagrid',
                unlabeled: 'Unlabeled column #%{column}',
            },
            SimpleForm: {
                title: 'Form',
                unlabeled: 'Unlabeled input #%{input}',
            },
            SimpleList: {
                title: 'List',
                primaryText: 'Primary text',
                secondaryText: 'Secondary text',
                tertiaryText: 'Tertiary text',
            },
        },
    },
};

export const en = {
    ...englishMessages,
    resources: {
        companies: {
            name: 'Company |||| Companies',
            fields: {
                name: 'Name',
                email: 'Email',
                phone: 'Phone',
                street: 'Street',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                billingStreet: 'Billing Street',
                billingZip: 'Billing ZIP Code',
                billingCity: 'Billing City',
                billingCountry: 'Billing Country',
                taxId: 'Tax ID / VAT Number',
                commercialRegister: 'Commercial Register Number',
                website: 'Website',
                active: 'Active',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                address: 'Address',
                billing: 'Billing Address',
                legal: 'Legal Information',
            },
        },
        users: {
            name: 'User |||| Users',
            fields: {
                email: 'Email',
                firstName: 'First Name',
                lastName: 'Last Name',
                phone: 'Phone',
                mobile: 'Mobile',
                street: 'Street',
                zip: 'ZIP Code',
                city: 'City',
                country: 'Country',
                dateOfBirth: 'Date of Birth',
                jobTitle: 'Job Title',
                department: 'Department',
                language: 'Preferred Language',
                company: 'Company',
                roles: 'Roles',
                userRoles: 'Roles',
                password: 'Password',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
            tabs: {
                general: 'General',
                contact: 'Contact & Address',
                work: 'Work Information',
                personal: 'Personal',
                roles: 'Roles & Permissions',
            },
        },
        invitations: {
            name: 'Invitation |||| Invitations',
            fields: {
                email: 'Email',
                company: 'Company',
                roles: 'Roles',
                token: 'Token',
                createdAt: 'Created at',
                expiresAt: 'Expires at',
                used: 'Used',
                usedAt: 'Used at',
                invitedBy: 'Invited by',
                registeredUser: 'Registered User',
            },
        },
        roles: {
            name: 'Role |||| Roles',
            fields: {
                name: 'Name',
                description: 'Description',
                permissions: 'Permissions',
            },
        },
        permissions: {
            name: 'Permission |||| Permissions',
            fields: {
                name: 'Name',
                description: 'Description',
            },
        },
        products: {
            name: 'Product |||| Products',
            fields: {
                name: 'Name',
                description: 'Description',
                price: 'Price',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
        },
        licenses: {
            name: 'License |||| Licenses',
            fields: {
                company: 'Company',
                product: 'Product',
                validFrom: 'Valid from',
                validUntil: 'Valid until',
                maxUsers: 'Max. Users',
                createdAt: 'Created at',
                updatedAt: 'Updated at',
            },
        },
    },
    custom: {
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        passwordChanged: 'Password changed successfully',
        language: 'Language',
        profile: {
            menuItem: 'My Profile',
            emailLocked: 'Email addresses can only be changed by superadmins. Please contact support.',
            title: 'My Profile',
            notLoggedIn: 'You are not logged in',
        },
    },
    profile: {
        avatar: {
            title: 'Profile Picture',
            hint: 'JPG, PNG, GIF or WebP. Max. 2 MB.',
            remove: 'Remove picture',
            uploadSuccess: 'Profile picture uploaded successfully',
            uploadError: 'Error uploading profile picture',
            deleteSuccess: 'Profile picture removed',
            deleteError: 'Error removing profile picture',
            invalidType: 'Invalid file format. Allowed: JPG, PNG, GIF, WebP',
            tooLarge: 'File too large. Maximum 2 MB.',
        },
    },
    courseEnrollmentDialog: {
        title: 'Participants',
        addUser: 'Enroll User',
        bulkEnroll: 'Bulk Enrollment',
        selectUser: 'Select User',
        enroll: 'Enroll',
        remove: 'Remove',
        enrollSuccess: 'User successfully enrolled',
        enrollError: 'Error enrolling user',
        alreadyEnrolled: 'This user is already enrolled',
        removeSuccess: 'Participant successfully removed',
        removeError: 'Error removing participant',
        confirmRemove: 'Do you really want to remove this participant?',
        loadError: 'Error loading participants',
        noEnrollments: 'No participants enrolled yet',
        table: {
            name: 'Name',
            email: 'Email',
            status: 'Status',
            progress: 'Progress',
            enrolledAt: 'Enrolled on',
        },
        status: {
            enrolled: 'Enrolled',
            in_progress: 'In Progress',
            completed: 'Completed',
            failed: 'Failed',
            pending_approval: 'Pending',
            rejected: 'Rejected',
        },
    },
    enrollments: {
        manage: {
            title: 'Manage Enrollments',
            importCsv: 'Import CSV',
            exportCsv: 'Export CSV',
            enrollUser: 'Enroll User',
            bulkEnroll: 'Bulk enrollment',
            bulkPartial: '%{enrolled} enrolled, %{skipped} skipped, %{failed} not enrolled: %{reason}',
            bulkCourse: 'Course',
            deleteConfirm: 'Delete the enrollment of %{user} in "%{course}"? The learning progress in this course will be lost. This cannot be undone.',
            selectCourse: 'Select Course',
            allCourses: 'All Courses',
            statusFilter: 'Status Filter',
            statusAll: 'All',
            statusEnrolled: 'Enrolled',
            statusInProgress: 'In Progress',
            statusCompleted: 'Completed',
            statusFailed: 'Failed',
            loading: 'Loading enrollments...',
            noEnrollments: 'No enrollments found for this course.',
            table: {
                name: 'Name',
                email: 'Email',
                course: 'Course',
                status: 'Status',
                progress: 'Progress',
                score: 'Score',
                enrolled: 'Enrolled',
                started: 'Started',
                completed: 'Completed',
                time: 'Time',
                actions: 'Actions',
            },
            dialog: {
                title: 'Enroll User',
                user: 'User',
                userHelp: 'Select a user from the SSO system',
                course: 'Course',
                enroll: 'Enroll',
            },
        },
        dashboard: {
            title: 'Enrollment Dashboard',
            enrollUser: 'Enroll User',
            stats: {
                total: 'Total Enrollments',
                active: 'Active Learners',
                completed: 'Completed',
                avgProgress: 'Avg. Progress',
            },
            courseStats: {
                title: 'Course Statistics',
                noData: 'No course data available.',
                table: {
                    course: 'Course',
                    enrollments: 'Enrollments',
                    completionRate: 'Completion Rate',
                    avgProgress: 'Avg. Progress',
                    avgScore: 'Avg. Score',
                },
            },
        },
        csvImport: {
            title: 'CSV Import - Enroll Users',
            formatInfo: 'CSV Format: One email address per line. First line will be skipped as header.',
            course: 'Course',
            selectFile: 'Select CSV File',
            file: 'File',
            import: 'Import',
            selectFileAndCourse: 'Please select a CSV file and a course',
            userNotFound: 'User not found',
            enrollError: 'Error enrolling',
            importComplete: 'Import completed: %{success} successful, %{failed} failed',
            processingError: 'Error processing CSV file',
            results: {
                success: 'Successful',
                failed: 'Failed',
                errors: 'Errors',
            },
        },
    },
    menu: {
        dashboard: 'Dashboard',
        mediaLibrary: 'Media Library',
        wiki: 'News & Knowledge',
        courses: 'Courses',
        courseCatalogs: 'Course Catalogs',
        aiGenerator: 'AI generator',
        knowledgeBase: 'Knowledge base',
        courseCatalog: 'Course Catalog',
        learningPaths: 'Learning Paths',
        achievements: 'My Achievements',
        enrollmentDashboard: 'Enrollment Dashboard',
        manageEnrollments: 'Manage Enrollments',
        enrollments: 'Enrollments',
        myCourses: 'My Courses',
        myCertificates: 'My Certificates',
        bookmarks: 'My Bookmarks',
        analytics: 'Statistics',
        library: 'Library',
        instructorAnalytics: 'Instructor Dashboard',
        learningGroups: 'Learning Groups',
        peerReview: 'Peer Reviews',
        notes: 'My Notes',
        certificates: 'Certificates',
    },
    dashboard: {
        title: 'Dashboard',
        defaultName: 'Learner',
        welcome: 'Welcome back, %{firstName}!',
        subtitle: 'Your Learning and Knowledge Portal',
        quickAccess: 'Quick Access',
        pendingReviews: 'Pending Reviews',
        myLearningGroups: 'My Learning Groups',
        stats: {
            myCourses: 'My Courses',
            inProgress: 'In Progress',
            completed: 'Completed',
            wikiArticles: 'Wiki Articles',
            media: 'Media',
        },
        quickAccessCards: {
            myCourses: {
                title: 'My Courses',
                description: 'Continue your learning',
            },
            catalogs: {
                title: 'Course Management',
                description: 'Create and edit catalogs + courses',
            },
            catalog: {
                title: 'Course Catalog',
                description: 'Discover and enroll in new courses',
            },
            wiki: {
                title: 'Wiki',
                description: 'Browse news & knowledge',
            },
            media: {
                title: 'Media Library',
                description: 'Manage files',
            },
        },
        activities: {
            mostViewed: '📈 Most Viewed Articles',
            recentArticles: '🆕 Recent Articles',
            recentFiles: '📁 Recent Files',
            noArticles: 'No articles available',
            noNewArticles: 'No new articles',
            noFiles: 'No files available',
            views: 'views',
            published: 'Published',
            draft: 'Draft',
        },
    },
    myCourses: {
        title: 'My Courses',
        loading: 'Loading courses...',
        courseNotFound: 'Course not found',
        enrolled: 'Enrolled',
        learningTime: 'Learning time',
        completed: 'Completed',
        noEnrollments: 'You are currently not enrolled in any courses. Please contact your administrator to enroll in courses.',
        noCoursesInProgress: 'No courses in progress.',
        allCoursesStarted: 'All courses have already been started.',
        noCoursesCompleted: 'No courses completed yet.',
        status: {
            completed: 'Completed',
            inProgress: 'In Progress',
            failed: 'Failed',
            notStarted: 'Not started yet',
            pendingApproval: 'Pending',
            rejected: 'Rejected',
            suspended: 'Suspended',
        },
        buttons: {
            start: 'Start Course',
            continue: 'Continue',
            review: 'Review again',
            retry: 'Try again',
        },
        tabs: {
            all: 'All (%{count})',
            inProgress: 'In Progress (%{count})',
            notStarted: 'Not Started (%{count})',
            completed: 'Completed (%{count})',
        },
    },
    certificates: {
        title: 'My Certificates',
        loading: 'Loading certificates...',
        noCertificates: 'No certificates available.',
        search: 'Search certificates...',
        download: 'Download',
        shareTooltip: 'Copy verification link',
        linkCopied: 'Link copied to clipboard',
        copyFailed: 'Copy failed',
        issuedAt: 'Issued on',
        expiresAt: 'Valid until',
        score: 'Score',
        verificationCode: 'Verification Code',
        status: {
            valid: 'Valid',
            expired: 'Expired',
            expiringSoon: 'Expires in %{days} days',
        },
        tabs: {
            all: 'All (%{count})',
            valid: 'Valid (%{count})',
            expired: 'Expired (%{count})',
        },
    },
    layout: {
        language: 'Language',
        profile: 'Profile',
        changePassword: 'Change Password',
        help: 'Help',
        logout: 'Logout',
        loadingTranslations: 'Loading translations...',
    },
    bottomNav: {
        catalogs: 'Catalogs',
        media: 'Media',
        learningPaths: 'Paths',
        achievements: 'Achievements',
    },
    wiki: {
        title: 'News & Knowledge',
        newArticle: 'New Article',
        searchPlaceholder: 'Search articles (title and summary)...',
        categoriesButton: 'Categories',
        categoryLabel: 'Category',
        allCategories: 'All Categories',
        noArticles: 'No articles found',
        loading: 'Loading...',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        confirmDelete: 'Do you really want to delete the article "%{title}"?',
        deleted: 'Article deleted',
        deleteError: 'Error deleting',
        loadError: 'Error loading articles',
        company: 'Company',
        platform: 'FAQ',
        updated: 'Updated',
        editor: {
            newArticle: 'New Article',
            editArticle: 'Edit Article',
            back: 'Back',
            save: 'Save',
            saving: 'Saving...',
            saveAndPublish: 'Save & Publish',
            title: 'Title',
            slug: 'URL Slug',
            slugHelp: 'URL-friendly name (auto-generated)',
            summary: 'Summary',
            summaryHelp: 'Short description for article overview',
            status: 'Status',
            category: 'Category',
            none: 'None',
            visibility: 'Visibility',
            visibilityCompany: 'Company (visible to company users only)',
            visibilityGlobal: 'Global (visible to all companies)',
            content: 'Content',
            version: 'Version',
            versionHistory: 'Version History',
        },
        status: {
            draft: 'Draft',
            published: 'Published',
            archived: 'Archived',
        },
        tabs: {
            all: 'All',
            drafts: 'Drafts',
            published: 'Published',
            archived: 'Archived',
        },
        favorites: 'Favorites',
        noFavorites: 'No favorites yet',
        noFavoritesHint: 'Mark articles as favorites to quickly find them here.',
        categories: {
            title: 'Wiki Categories',
            back: 'Back',
            newCategory: 'New Category',
            editCategory: 'Edit Category',
            noCategories: 'No categories available',
            loadError: 'Error loading categories',
            saveError: 'Error saving',
            deleteError: 'Error deleting',
            updateSuccess: 'Category updated',
            createSuccess: 'Category created',
            deleteSuccess: 'Category deleted',
            nameRequired: 'Please enter a name',
            confirmDelete: 'Do you really want to delete the category "%{name}"?',
            companyCategory: 'Company Category',
            globalCategory: 'Global Category',
            table: {
                name: 'Name',
                color: 'Color',
                icon: 'Icon',
                description: 'Description',
                type: 'Type',
                actions: 'Actions',
            },
            form: {
                name: 'Name',
                color: 'Color',
                icon: 'Icon (Optional)',
                noIcon: 'No Icon',
                description: 'Description',
                globalCategory: 'Global Category (visible to all companies)',
            },
            isPublic: 'Public (FAQ)',
            isPublicHelp: 'Public categories are accessible without login at /faq',
        },
    },
    courses: {
        title: 'Courses',
        catalog: 'Catalog',
        backToCatalogs: 'Back to Catalogs',
        coursesIn: 'Courses in: %{name}',
        newCourse: 'New Course',
        editCourse: 'Edit Course',
        createFirst: 'Create First Course',
        manageLessons: 'Manage Lessons',
        fromLibrary: 'From Library',
        noCourses: 'No courses available yet',
        loading: 'Loading courses...',
        loadError: 'Error loading catalog',
        loadCoursesError: 'Error loading courses',
        saveError: 'Error saving course',
        deleteError: 'Error archiving course',
        updateSuccess: 'Course successfully updated',
        createSuccess: 'Course successfully created',
        deleteSuccess: 'Course successfully archived',
        confirmDelete: 'Do you really want to archive this course?\n\nThe course will become invisible and inaccessible for all participants. Existing certificates will be preserved. Statistics will not be affected.',
        sequential: 'Sequential',
        duration: '%{minutes} min.',
        lessonsCount: '%{count} lessons',
        difficulty: {
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
        },
        form: {
            title: 'Title',
            slug: 'Slug',
            slugHelp: 'URL-friendly identifier (e.g. introduction-javascript)',
            description: 'Description',
            estimatedDuration: 'Estimated Duration (minutes)',
            difficulty: 'Difficulty',
            requireSequentialCompletion: 'Require Sequential Completion',
            active: 'Active',
            tags: 'Tags',
            tagsHelp: 'Comma-separated list (e.g. react, javascript, frontend)',
            certificateType: 'Certificate for course completion',
            certificateTypeParticipated: 'Certificate: participated in the course',
            certificateTypePassed: 'Certificate: passed the course',
            certificateTypeNone: 'Do not issue a certificate',
            certificateTypeRequired: 'Please choose which certificate the course issues.',
            certificateTypePassedWithoutThreshold: 'No lesson has a minimum score – every completion counts as passed. You set the minimum score per lesson.',
            aiTutorEnabled: 'Enable AI Learning Assistant',
            requireTeacherReviewForGrading: 'AI grades require approval by an authorised person (certificate-relevant courses)',
        },
    },
    catalogs: {
        title: 'Course Catalogs',
        loading: 'Loading catalogs...',
        loadError: 'Error loading catalogs',
        newCatalog: 'New Catalog',
        editCatalog: 'Edit Catalog',
        manageCourses: 'Manage Courses',
        active: 'Active',
        inactive: 'Inactive',
        coursesCount: '%{count} courses',
        created: 'Created',
        confirmDelete: 'Do you really want to delete this catalog?',
        updateSuccess: 'Catalog successfully updated',
        createSuccess: 'Catalog successfully created',
        deleteSuccess: 'Catalog successfully deleted',
        saveError: 'Error saving catalog',
        deleteError: 'Error deleting catalog',
        form: {
            name: 'Name',
            description: 'Description',
            active: 'Active',
        },
    },
    blockEditor: {
        ariaLabel: 'Lesson content',
        loading: 'Loading editor …',
        placeholder: {
            richtext: 'Write something or type "/" for blocks …',
            heading: 'Heading …',
            quote: 'Enter a quote …',
            code: '// write code here …',
        },
        toolbar: {
            undo: 'Undo',
            redo: 'Redo',
            bold: 'Bold',
            italic: 'Italic',
            underline: 'Underline',
            strike: 'Strikethrough',
            link: 'Link',
        },
        library: {
            title: 'Block library',
            toggle: 'Blocks',
            close: 'Close block library',
            search: 'Search blocks …',
            empty: 'No blocks matching "%{query}"',
            hint: 'Tip: type "/" in a text block to insert a block quickly.',
        },
        slash: {
            title: 'Insert block',
            results: '%{smart_count} result for "%{query}" |||| %{smart_count} results for "%{query}"',
        },
        actions: {
            toolbar: 'Block actions',
            drag: 'Drag to move',
            switchType: 'Change block type',
            convertTo: 'Convert to …',
            noMatch: 'No matching block types',
            moveUp: 'Move up',
            moveDown: 'Move down',
            duplicate: 'Duplicate block',
            delete: 'Delete block',
        },
        views: {
            loadingMedia: 'Loading media …',
            pickFromLibrary: 'Choose from media library',
            replace: 'Replace',
            explanation: 'Explanation (optional)',
            explanationHint: 'Shown to learners after answering.',
            video: { empty: 'No video selected yet', poster: 'Poster image', posterChange: 'Change poster', posterRemove: 'Remove poster', chapters: '%{smart_count} chapter |||| %{smart_count} chapters', addChapter: 'Chapter', seconds: 'Second', chapterTitle: 'Chapter title' },
            audio: { empty: 'No audio file selected yet', title: 'Title' },
            file: { empty: 'No file selected yet', unnamed: 'Unnamed file' },
            pdf: { empty: 'No PDF selected yet' },
            embed: { empty: 'Enter the URL of a YouTube or Vimeo video', linkOnly: 'Unknown provider – learners will see a link: %{url}', url: 'URL', ratio: 'Ratio' },
            table: { header: 'Header row', addRow: 'Row', addColumn: 'Add column', removeRow: 'Remove row', removeColumn: 'Remove column', headerPlaceholder: 'Column %{n}', caption: 'Table caption (optional)' },
            timeline: { entries: '%{smart_count} entry |||| %{smart_count} entries', add: 'Entry', date: 'Date or period', title: 'Title', description: 'Description' },
            quiz: { single: 'Quiz (single answer)', multi: 'Quiz (multiple answers)', multiSelect: 'Multiple answers', question: 'Question', option: 'Answer %{n}', addOption: 'Answer', removeOption: 'Remove answer', markCorrect: 'Mark as correct', markedCorrect: 'Marked as correct' },
            fillBlank: { count: '%{smart_count} blank |||| %{smart_count} blanks', insert: 'Blank', template: 'Text with blanks', templateHint: 'Write blanks as {{blank_1}} or insert them via "Blank".', answers: 'Accepted answers per blank (comma separated)', answersPlaceholder: 'Answer 1, answer 2, …', caseSensitive: 'Case', remove: 'Remove blank' },
            matching: { count: '%{smart_count} pair |||| %{smart_count} pairs', add: 'Pair', left: 'Left side', right: 'Right side', term: 'Term %{n}', match: 'Match %{n}', remove: 'Remove pair', shuffleHint: 'The right side is shown to learners in shuffled order.' },
            ordering: { hint: 'Enter in the correct order', add: 'Item', step: 'Step %{n}', remove: 'Remove item', shuffleHint: 'Items are shown to learners in shuffled order.' },
            flashcard: { count: '%{smart_count} card |||| %{smart_count} cards', add: 'Card', card: 'Card %{n}', front: 'Front', back: 'Back', remove: 'Remove card' },
            poll: { question: 'Poll question', option: 'Option %{n}', addOption: 'Option', removeOption: 'Remove option', multiSelect: 'Multiple choice', showResults: 'Show results' },
            stage: { choose: 'Choose image', replace: 'Replace image', clickHint: 'Click into the image to add a point.' },
            hotspot: { count: '%{smart_count} area |||| %{smart_count} areas', empty: 'Choose an image from the media library, then mark areas.', label: 'Label', description: 'Description', add: 'Area', remove: 'Remove area' },
            labeling: { count: '%{smart_count} point |||| %{smart_count} points', empty: 'Choose an image, then place the points to be named.', text: 'Expected label', add: 'Point', remove: 'Remove point' },
            sorting: { category: 'Category', newCategory: 'Category %{n}', addCategory: 'Category', removeCategory: 'Remove category', item: 'Item %{n}', addItem: 'Item', removeItem: 'Remove item' },
            sliderScale: { question: 'Question or statement', minLabel: 'Minimum label', maxLabel: 'Maximum label', min: 'Minimum', max: 'Maximum', step: 'Step' },
            discussion: { prompt: 'Discussion prompt', allowReplies: 'Allow replies', moderation: 'Moderation required' },
            branching: { count: '%{smart_count} node |||| %{smart_count} nodes', start: 'Start node', startChip: 'Start', addNode: 'Node', removeNode: 'Remove node', question: 'Question or situation', option: 'Option', next: 'Continue to', end: '— End —', addOption: 'Option', removeOption: 'Remove option' },
            simulation: { count: '%{smart_count} step |||| %{smart_count} steps', scenario: 'Scenario', addStep: 'Step', removeStep: 'Remove step', stepText: 'Situation / decision point', choice: 'Choice', correct: 'Correct', feedback: 'Feedback for this choice', addChoice: 'Choice', removeChoice: 'Remove choice' },
            scorm: { title: 'Title', version: 'SCORM version', empty: 'No package yet – upload a ZIP or pick one from the media library; it is extracted automatically.', attached: 'Package "%{title}" is ready.', upload: 'Upload package', replace: 'Replace', library: 'Media library', processing: 'Processing package …', ready: 'SCORM package ready.', extractError: 'The package could not be extracted.', uploadError: 'Upload failed.', zipOnly: 'Please choose a SCORM package as .zip.' },
            h5p: { title: 'Title', embedUrl: 'Embed URL (optional)', embedHint: 'Leave empty when the content is created in the H5P editor.', create: 'Create H5P content', edit: 'Edit H5P content', attached: 'H5P content #%{id} linked.', empty: 'No H5P content yet.' },
            columns: { choose: 'Choose a column layout', preset: { '2': '2 equal', '3': '3 equal', '2-1': '2/3 + 1/3', '1-2': '1/3 + 2/3' }, count: '%{smart_count} column |||| %{smart_count} columns', changeLayout: 'Change layout', add: 'Column', column: 'Column %{n}', remove: 'Remove column' },
            accordion: { count: '%{smart_count} section |||| %{smart_count} sections', allowMultiple: 'Multiple open', add: 'Section', newItem: 'Section %{n}', titlePlaceholder: 'Section title …', defaultOpen: 'Open', expand: 'Expand', collapse: 'Collapse', remove: 'Remove section' },
            tabs: { count: '%{smart_count} tab |||| %{smart_count} tabs', add: 'Tab', newTab: 'Tab %{n}', label: 'Label', remove: 'Remove tab' },
        },
        categories: { content: 'Content', layout: 'Layout', interactive: 'Interactive' },
        callout: {
            placeholder: 'Enter the text of the callout …',
            variant: 'Variant',
            text: 'Text',
            htmlHint: 'Simple HTML allowed (<p>, <strong>, <a>)',
            variants: { info: 'Info', warning: 'Warning', success: 'Success', danger: 'Danger', tip: 'Tip' },
        },
        image: {
            empty: 'No image selected yet',
            fromLibrary: 'Choose from media library',
            replace: 'Replace image',
            alt: 'Alternative text',
            caption: 'Caption',
            alignment: { label: 'Alignment', left: 'Left', center: 'Center', right: 'Right' },
        },
        types: {
            richtext: { label: 'Text', description: 'Plain text paragraph' },
            heading1: { label: 'Heading 1', description: 'Large section heading' },
            heading2: { label: 'Heading 2', description: 'Medium section heading' },
            heading3: { label: 'Heading 3', description: 'Small section heading' },
            image: { label: 'Image', description: 'Image from the media library' },
            quote: { label: 'Quote', description: 'Quote block with attribution' },
            code: { label: 'Code', description: 'Code block in monospace' },
            divider: { label: 'Divider', description: 'Horizontal divider line' },
            callout: { label: 'Callout', description: 'Highlighted info, warning or tip box' },
            video: { label: 'Video', description: 'Video from the media library' },
            audio: { label: 'Audio', description: 'Embed an audio file' },
            file: { label: 'File', description: 'Attach a file for download' },
            embed: { label: 'Embed', description: 'Embed external content (YouTube, Vimeo …)' },
            timeline: { label: 'Timeline', description: 'Timeline with dated events' },
            pdf_viewer: { label: 'PDF', description: 'Embed a PDF document' },
            columns: { label: 'Columns', description: 'Multi-column layout (2–4 columns)' },
            accordion: { label: 'Accordion', description: 'Collapsible content sections' },
            tabs: { label: 'Tabs', description: 'Arrange content in tabs' },
            table: { label: 'Table', description: 'Data table with optional header row' },
            inline_quiz: { label: 'Quiz', description: 'Multiple-choice question inline' },
            fill_blank: { label: 'Fill in the blanks', description: 'Text with blanks to fill in' },
            matching: { label: 'Matching', description: 'Match pairs with each other' },
            ordering: { label: 'Ordering', description: 'Put items into the right order' },
            flashcard: { label: 'Flashcards', description: 'Flip cards for memorising' },
            poll: { label: 'Poll', description: 'Poll or vote question' },
            discussion: { label: 'Discussion', description: 'Discussion prompt for participants' },
            slider_scale: { label: 'Scale', description: 'Self-assessment on a rating scale' },
            sorting: { label: 'Sorting', description: 'Sort items into groups' },
            hotspot: { label: 'Hotspot', description: 'Image with clickable areas' },
            labeling: { label: 'Labeling', description: 'Label points on an image' },
            h5p: { label: 'H5P content', description: 'Embed interactive H5P content' },
            scorm_embed: { label: 'SCORM package', description: 'Embed a SCORM learning package' },
            code_sandbox: { label: 'Code sandbox', description: 'Interactive programming task' },
            branching: { label: 'Branching', description: 'Decision tree with branching paths' },
            simulation: { label: 'Simulation', description: 'Decision scenario with consequences' },
            photo_task: { label: 'Photo task', description: 'Workplace photo checked against criteria' },
        },
    },
    mediaPicker: {
        title: { image: 'Choose an image', video: 'Choose a video', audio: 'Choose an audio file', document: 'Choose a document', any: 'Choose a file' },
        search: 'Search files …',
        upload: 'Upload',
        empty: 'No matching files in the media library',
        loadError: 'Could not load the media library',
        uploadSuccess: 'File uploaded',
        uploadError: 'Upload failed',
    },
    blockLesson: {
        preview: { show: 'Preview', edit: 'Edit' },
        saveError: 'Lesson could not be saved',
        shortcutsHint: 'Tip: "/" opens the block menu, Ctrl+S saves immediately. Changes are saved automatically.',
        minScore: 'Minimum score (%)',
        minScoreHint: 'Default: 70%',
        status: {
            idle: 'Saved',
            unsaved: 'Unsaved changes',
            saving: 'Saving …',
            saved: 'Saved',
            savedAt: 'Saved %{time}',
            error: 'Saving failed',
        },
        completionRule: {
            label: 'Completion rule',
            hint: 'Defines when learners may complete the lesson.',
            view_only: 'Viewing is enough',
            scroll_through: 'Read to the end',
            all_interactions: 'Complete all exercises',
            quiz_passed: 'Reach the minimum score',
            manual: 'Complete manually',
        },
        versions: {
            title: 'Versions',
            empty: 'No earlier versions yet',
            version: 'Version %{version}',
            blocks: '%{smart_count} block |||| %{smart_count} blocks',
            restore: 'Restore',
            confirmRestore: 'Restore version %{version}? The current state is saved as a version first.',
            restored: 'Version %{version} restored',
            restoreError: 'Version could not be restored',
            loadError: 'Versions could not be loaded',
            commentPlaceholder: 'Version note, e.g. "Image changed"',
            saveNamed: 'Save version',
            saved: 'Version saved',
            saveError: 'Version could not be saved',
            retention: 'Consecutive automatic saves are merged. At most %{max} versions are kept, older ones drop out – named versions last.',
            source: { autosave: 'Automatic', manual: 'Manual', pre_restore: 'Before restore' },
        },
    },
    courseBuilder: {
        classicLesson: { hint: 'This lesson (e.g. free-text questions from the AI generator) uses the classic format and cannot be edited in the block editor.', open: 'Open classic editor' },
        quality: 'AI quality',
        sources: 'Sources',
        sourcesDialog: { title: 'Cited sources', empty: 'This course cites no sources from the knowledge base.', count: '%{count} sources in %{lessons} lessons', retired: 'Source superseded – review lesson', page: 'p. %{page}' },
        format: {
            label: 'Content format',
            classic: 'Classic (existing lesson types)',
            blocks: 'Authoring tool v2 (sections + blocks)',
        },
        title: 'Course builder – %{title}',
        badge: 'Authoring tool v2',
        inactive: 'Inactive',
        structure: 'Course structure',
        loadError: 'Course could not be loaded',
        reorderError: 'Order could not be saved',
        empty: {
            title: 'Select a lesson',
            hint: 'Pick a lesson on the left or create a new lesson inside a section.',
        },
        section: {
            add: 'Section',
            rename: 'Rename section',
            titleField: 'Section title',
            untitled: 'New section',
            empty: 'No sections yet. Create a section first, then lessons inside it.',
            unassigned: 'Without section',
            notEmpty: 'The section still contains lessons. Move or delete them first.',
            confirmDelete: 'Delete section "%{title}"?',
            saveError: 'Section could not be saved',
            deleteError: 'Section could not be deleted',
        },
        lesson: {
            add: 'Lesson',
            edit: 'Edit lesson',
            move: 'Move to …',
            menu: 'Lesson menu',
            titleField: 'Lesson title',
            duration: 'Duration (minutes)',
            untitled: 'New lesson',
            blocks: '%{smart_count} block |||| %{smart_count} blocks',
            saveError: 'Lesson could not be saved',
        },
    },
    aiGenerator: {
        pageTitle: 'AI generator',
        badge: 'AI suite',
        modes: { label: 'Choose generator', content: 'Building blocks', course: 'Whole course' },
        knowledge: { use: 'Use knowledge base', hint: 'The AI backs statements with sources from the knowledge base and cites them per lesson.', sources: 'Only these sources (empty = all)', sourcesLabel: 'Sources', none: 'No sources available – add them under Knowledge base.', cited: 'Sources: %{count}' },
        quota: {
            content: 'Today %{used} of %{limit} block jobs',
            course: 'Today %{used} of %{limit} course generations',
            exhausted: 'Your company has reached its daily limit. Continue tomorrow, or ask the operator to raise it.',
        },
        material: {
            mode: 'Choose source',
            text: 'Text',
            url: 'Web page',
            file: 'File',
            urlField: 'Web page address',
            fetch: 'Load text',
            fetched: 'Web page loaded (%{chars} characters).',
            fetchError: 'The web page could not be loaded.',
            chooseFile: 'Choose PDF, DOCX or PPTX',
            fileHint: 'Max. 15 MB – the file is not stored, only its text is used.',
            extracted: 'Text taken from the file (%{chars} characters).',
            extractError: 'No text could be read from the file.',
            textField: 'Source material',
            chars: '%{chars} characters (min. %{min})',
            charsOptional: '%{chars} characters – optional while the knowledge base is used: leave empty for the selected sources or name the topic briefly.',
            source: 'Source: %{source}',
            truncated: 'Truncated to the maximum length.',
        },
        fields: { language: 'Language', difficulty: 'Difficulty', difficultyAny: 'No preference' },
        difficulty: { beginner: 'Beginner', intermediate: 'Intermediate', advanced: 'Advanced' },
        types: {
            lesson_draft: 'Lesson draft (blocks)',
            summary: 'Summary',
            key_points: 'Key points',
            flashcards: 'Flashcards',
            multiple_choice: 'Multiple-choice questions',
            true_false: 'True/false questions',
            free_text_question: 'Free-text questions',
        },
        sources: { plain_text: 'Text', url: 'Web page', existing_course: 'Existing course', pdf: 'PDF', docx: 'DOCX', pptx: 'PPTX' },
        status: { pending: 'Queued', processing: 'Running', completed: 'Done', failed: 'Failed' },
        contentStatus: { pending: 'To review', accepted: 'Imported', rejected: 'Rejected' },
        content: {
            title: 'Generate building blocks from material',
            intro: 'Paste text, load a web page or upload a file – the AI turns it into building blocks you review and import into a course.',
            types: 'What should be generated?',
            noTypes: 'Please choose at least one type.',
            submit: 'Generate blocks',
            created: 'Job started – the result will appear in the list.',
            createError: 'The job could not be started.',
        },
        course: {
            title: 'Draft a whole course',
            intro: 'Describe topic and learning goal – the AI plans sections and lessons with knowledge checks and creates an inactive draft course for review in the builder.',
            topic: 'Topic',
            goal: 'Audience and learning goal',
            goalPlaceholder: 'e.g. New warehouse staff should set up and inspect ladders safely.',
            catalog: 'Target catalog',
            noCatalogs: 'No course catalog yet – please create one first.',
            material: 'Optional: source material the course should be based on',
            submit: 'Generate course draft',
            created: 'Course generation started – progress appears in the list.',
            createError: 'The course generation could not be started.',
        },
        jobs: {
            title: 'Jobs',
            refresh: 'Refresh',
            empty: 'No jobs yet.',
            loadError: 'Jobs could not be loaded.',
            contentJob: 'Job #%{id}',
            items: '%{smart_count} result |||| %{smart_count} results',
            failed: 'The job failed.',
            openBuilder: 'Open in builder',
        },
        results: {
            title: 'Results of job #%{id}',
            empty: 'The job returned no results.',
            preview: 'Preview',
            hidePreview: 'Close preview',
            previewError: 'The preview could not be generated.',
            sampleAnswer: 'Sample answer',
            accept: 'Import',
            reject: 'Reject',
            rejected: 'Result rejected.',
            rejectError: 'The result could not be rejected.',
            acceptTitle: 'Import into course',
            acceptHint: 'The block becomes a new lesson or is appended to an existing lesson of the course. In v2 courses a new lesson goes into the chosen section or into "AI drafts".',
            targetLesson: 'Target lesson',
            newLesson: 'Create new lesson',
            source: 'Request',
            targetCourse: 'Target course',
            targetSection: 'Section',
            draftSection: 'Section "AI drafts" (will be created)',
            accepted: 'Lesson "%{lesson}" was created in "%{course}".',
            acceptError: 'The import failed.',
            openLesson: 'Open lesson',
        },
    },
    courseQuality: {
        title: 'AI quality check',
        badge: 'v2',
        back: 'Back to course',
        start: 'Start new analysis',
        started: 'Analysis started – the result will appear shortly.',
        startError: 'The analysis could not be started.',
        loadError: 'Quality data could not be loaded.',
        disclaimer: 'The score is an AI assessment of structure, texts and questions. Media quality (videos, SCORM, H5P) is not rated – please review editorially.',
        running: 'Analysis running … this usually takes 30–90 seconds.',
        failed: 'The analysis failed: %{error}',
        empty: { title: 'No analysis yet', hint: 'Start an AI quality analysis to get a score and improvement suggestions.' },
        overall: 'Overall score',
        checkedAt: 'Checked on %{date}',
        model: 'Model: %{model}',
        radarLabel: 'Quality radar across %{count} dimensions',
        notApplicable: 'n/a',
        dimensions: {
            structure: 'Structure',
            content_depth: 'Content depth',
            engagement: 'Engagement',
            accessibility: 'Accessibility',
            assessment_coverage: 'Assessment coverage',
            compliance: 'Mandatory contents',
            readability: 'Readability',
            learner_data: 'Learner data',
        },
        learnerData: {
            title: 'Learner data',
            hint: 'How the course performs in practice: completion rate, results and the lesson where learners drop out. The AI saw these numbers when it made its suggestions.',
            insufficient: 'Only %{count} enrollment(s) so far – learner data counts from 5 onwards.',
            enrollments: 'Enrollments',
            completionRate: 'Completion rate',
            inProgress: 'In progress',
            avgScore: 'Avg. score',
            avgTime: 'Avg. learning time',
            minutes: '%{minutes} min',
            funnel: 'Lesson funnel',
            started: 'started',
            completed: 'completed',
            exit: '%{rate} % leave before it',
            score: 'avg. %{score}',
            dropOff: 'Drop-off',
            lowScore: 'Low score',
        },
        suggestions: 'Improvement suggestions',
        strengths: 'Strengths',
        affected: 'Affects: %{lessons}',
        severity: { high: 'High', medium: 'Medium', low: 'Low' },
        compliance: {
            title: 'Mandatory contents of the instruction',
            covered: '%{covered} of %{total} covered',
            hint: 'Minimum contents per DGUV Vorschrift 1 § 4 and ArbSchG § 12. Add uncovered items before using the course as an instruction.',
            in: 'in: %{evidence}',
            missing: 'missing',
            items: {
                hazards: 'Hazards at the workplace',
                protective_measures: 'Protective measures and rules of conduct',
                ppe: 'Personal protective equipment',
                disturbances_emergencies: 'Conduct in malfunctions and emergencies',
                first_aid: 'First aid and emergency call',
                escape_routes: 'Escape and rescue routes',
                responsibilities: 'Responsibilities and reporting channels',
                legal_basis: 'Legal basis / company instruction named',
            },
        },
        readability: {
            title: 'Readability',
            badge: 'Grade %{grade} · %{score}/100',
            hint: 'Wiener Sachtextformel per lesson. For instructions the grade should stay below 8; above 10 shortening pays off.',
            words: '%{words} words',
            grade: 'Grade %{grade}',
        },
        history: 'Previous analyses',
        historyRow: 'Score %{score}/100 · %{status}',
        status: { pending: 'Queued', processing: 'Running', completed: 'Done', failed: 'Failed' },
    },
    provenance: {
        title: 'Origin and approval',
        origin: { manual: 'Created manually', generated: 'AI-generated', assisted: 'Created manually, AI content imported', variant: 'AI variant (translation / easy language)' },
        generatedBy: 'Generated by',
        model: 'Model',
        promptVersion: 'Prompt version',
        material: 'Source material',
        materialInfo: '%{chars} characters · SHA-256 %{hash}…',
        noMaterial: 'no uploaded material',
        derivedFrom: 'Derived from course',
        lastQuality: 'Last quality check: %{score}/100 on %{date}',
        gateHint: 'Your company requires a sign-off for AI-generated courses before they can be activated.',
        signedBy: 'Signed off by %{name} on %{date}',
        changedSince: 'The content changed since the sign-off – please review again.',
        signOffAgain: 'Sign off again',
        withdraw: 'Withdraw sign-off',
        notSigned: 'Not yet signed off',
        signHint: 'By signing off you confirm that you reviewed the current course content. Later edits are flagged as "changed since sign-off".',
        note: 'Note (optional)',
        signOff: 'Sign off course',
        signedOff: 'Course signed off.',
        withdrawn: 'Sign-off withdrawn.',
        actionError: 'Action failed.',
        badge: { generated: 'AI-generated', assisted: 'AI-assisted', variant: 'AI variant', signedOff: 'Signed off' },
    },
    knowledgeBase: {
        pageTitle: 'Knowledge base',
        platformTitle: 'Platform knowledge base',
        intro: 'Work instructions, risk assessments, procedures and regulations the AI generator and AI tutor rely on. Every source is split into sections and made searchable.',
        platformIntro: 'Sources without a company (general regulations) – readable by every company, managed only here.',
        embeddingsOff: 'No embedding endpoint configured – search is lexical only. Re-process the sources once the endpoint is live.',
        platformCount: 'Platform sources available: %{count}',
        add: { title: 'Add source', file: 'File', url: 'Web page', text: 'Text', fileHint: 'PDF, DOCX, PPTX, Markdown or text, max. 25 MB', urlLabel: 'Address (https://…)', textLabel: 'Paste text', submit: 'Create source', created: 'Source created – processing runs in the background.' },
        fields: { title: 'Title', publisher: 'Publisher', documentNumber: 'Document number', jurisdiction: 'Jurisdiction', license: 'Licence class', validFrom: 'As of (date)', supersedes: 'Supersedes previous version' },
        license: { internal: 'Internal', official_work: 'Official work', public_domain: 'Public domain', public_copyrighted: 'Public, copyrighted', licensed: 'Licensed' },
        licenseHint: 'For "Internal", "Official work" and "Public domain" the AI may quote verbatim, otherwise it paraphrases only.',
        status: { pending: 'Pending', processing: 'Processing', ready: 'Ready', failed: 'Failed' },
        list: { empty: 'No sources yet.', chunks: '%{count} sections', characters: '%{count} characters', version: 'Version %{version}', retired: 'Superseded', references: 'Cited in %{count} lessons', noEmbeddings: 'without embeddings', reingest: 'Re-process', delete: 'Delete', confirmDelete: 'Delete source "%{title}" and all its sections? Lesson citations lose their source.', deleted: 'Source deleted.', reingested: 'Processing started.' },
        search: { title: 'Test search', placeholder: 'Search term or question …', button: 'Search', empty: 'No hits.', hint: 'This is how the generator sees the knowledge base – the best sections become references [S1], [S2] … in the prompt.' },
        errors: { duplicate: 'This document already exists.', generic: 'The source could not be created.' },
    },
    helpBot: {
        title: 'Help assistant',
        aiLabel: 'AI',
        intro: 'I explain how to use online:academy. Questions about course content are answered by the AI tutor in the course player.',
        placeholder: 'How do I …?',
        send: 'Send',
        close: 'Close',
        clear: 'Clear history',
        error: 'The help assistant is currently unavailable.',
        disclaimer: 'AI-generated answers may contain mistakes. The history is not stored.',
        suggestions: { start: 'How do I get started?', certificates: 'Where are my certificates?', notifications: 'Which notifications exist?', player: 'How does the course player work?', notes: 'How do I write a note?', tutor: 'What can the AI tutor do?', enroll: 'How do I enrol in a course?', assignments: 'What is a mandatory assignment?', createCourse: 'How do I create a course?', lessons: 'Which lesson types exist?', aiGenerator: 'How do I use the AI generator?', assignmentCreate: 'How do I assign a mandatory task?', reminders: 'How do I set reminders?', overdue: 'How do I see overdue tasks?', knowledgeBase: 'What is the knowledge base for?', aiSettings: 'What do the AI settings control?', invite: 'How do I invite users?', roles: 'Which roles exist?', branding: 'How do I change logo and colours?' },
    },
    variants: {
        button: 'Variants',
        title: 'Language variants and easy-to-read',
        family: 'Course family',
        original: 'Original',
        inactive: 'inactive',
        outdated: 'Outdated – original changed',
        reviewRequired: 'Editorial review required',
        open: 'Open',
        jobs: 'Generations',
        create: 'Create a new variant',
        fromOriginal: 'Variants are derived from the original "%{title}".',
        kindLabel: 'Kind',
        kind: { translation: 'Translation', easy_language: 'Easy-to-read (Leichte Sprache)' },
        language: 'Target language',
        submit: 'Create variant',
        started: 'Variant is being created – progress appears in the list.',
        createError: 'The variant could not be started.',
        loadError: 'Variants could not be loaded.',
        status: { pending: 'Pending', processing: 'Running', completed: 'Done', failed: 'Failed' },
        skipped: '%{count} lesson(s) copied unchanged',
        reviewHint: 'The AI model is weaker in this language: the variant stays inactive until it has been reviewed and approved.',
        hint: 'The variant becomes its own inactive course with the same structure, inherits settings and citations and is linked next to the original in the catalog. If the original changes later, it is flagged "Outdated".',
        availableIn: 'Also available in',
    },
    aiSettings: {
        title: 'AI settings',
        intro: 'Which AI features your company uses, whether AI-generated courses need a sign-off before activation, and how the AI tutor is addressed.',
        company: 'Company',
        companyHint: 'As operator you pick the company by its id.',
        companyId: 'Company id',
        features: 'Features',
        switch: {
            contentGeneratorEnabled: 'AI generator (blocks and courses)',
            qualityCheckEnabled: 'AI quality check',
            knowledgeBaseEnabled: 'Knowledge base',
            helpBotEnabled: 'Help bot',
            recommendationsEnabled: 'AI course recommendations',
            learningPathsEnabled: 'AI learning paths',
            requireSignOffForAiCourses: 'Sign-off required for AI-generated courses',
        },
        switchHint: {
            contentGeneratorEnabled: 'Generates lesson blocks and complete course drafts from material.',
            qualityCheckEnabled: 'Rates courses in seven dimensions with improvement suggestions.',
            knowledgeBaseEnabled: 'Own documents as grounding for generator and tutor (tranche C).',
            helpBotEnabled: 'Usage help for users (tranche C).',
            recommendationsEnabled: 'The AI picks the best-fitting courses from the rule-based suggestions and explains them to the learner.',
            learningPathsEnabled: 'Learners build their own learning paths with the AI; authors have company paths drafted.',
            requireSignOffForAiCourses: 'AI-generated courses and variants can only be activated after a sign-off.',
        },
        tutorPrompt: 'Extra instruction for the AI tutor',
        tutorPromptHint: 'Optional: tone, form of address, company-specific hints. Prepended to the tutor prompt.',
        limits: 'Daily limits',
        limitsHint: 'Protects the shared AI backend. Higher limits are set by the operator.',
        limitsHintOperator: 'As operator you may adjust this company\'s daily limits (0 disables the feature).',
        cap: { dailyCourseGenerationLimit: 'Course generations / day', dailyContentJobLimit: 'Block jobs / day', dailyVariantLimit: 'Variants / day' },
        capDefault: 'Default: %{value}',
        saved: 'AI settings saved.',
        saveError: 'Saving failed.',
        loadError: 'AI settings could not be loaded.',
    },
    blockPlayer: {
        unsupported: 'This content type (%{type}) is not supported yet.',
        previewHint: 'Preview – answers are not recorded.',
        check: 'Check',
        retry: 'Try again',
        result: {
            correct: 'Correct!',
            incorrect: 'Not quite – %{percent}% correct.',
            attempt: 'Attempt %{n}',
            error: 'Your answer could not be sent.',
        },
        hotspot: { title: 'Hotspot exercise', hint: 'Click the marked areas to explore them.', progress: '%{done} of %{total} explored', area: 'Area %{n}' },
        labeling: { title: 'Labeling exercise', hint: 'Name the numbered points in the image.', answer: 'Label %{n}' },
        sorting: { title: 'Sorting exercise', hint: 'Drag every item into the matching category – or tap the category number.', placeIn: 'Put into "%{category}"', remove: 'Put back' },
        sliderScale: { title: 'Self-assessment', submit: 'Submit', saved: 'Your assessment was saved.' },
        discussion: { title: 'Discussion', count: '%{smart_count} post |||| %{smart_count} posts', empty: 'No posts yet – write the first one.', placeholder: 'Your post …', send: 'Send post', reply: 'Reply', replyingTo: 'Replying to a post', delete: 'Delete post', approve: 'Approve', reject: 'Reject', pending: 'Awaiting approval', rejected: 'Rejected', anonymous: 'Participant', moderationHint: 'Posts are reviewed by instructors before publication.', error: 'The post could not be saved.' },
        branching: { title: 'Branching', step: 'Step %{n}', done: 'Path completed (%{smart_count} decision) |||| Path completed (%{smart_count} decisions)', restart: 'Start over' },
        simulation: { title: 'Scenario task', decision: 'Decision %{n}', continue: 'Continue', finish: 'Finish', done: 'Scenario task completed.', restart: 'Start over' },
        scorm: { title: 'SCORM package', empty: 'SCORM package is not configured yet.', completed: 'Completed', fullscreen: 'Fullscreen' },
        h5p: { title: 'H5P content', empty: 'H5P content is not configured yet.' },
        quiz: { title: 'Quiz', multi: 'Multiple answers' },
        fillBlank: { title: 'Fill in the blanks', blank: 'Blank %{n}' },
        matching: { title: 'Matching', choose: 'Please choose …', correctIs: 'Correct: %{text}' },
        ordering: { title: 'Ordering', hint: 'Use the arrows to put the items into the right order.' },
        flashcard: { title: 'Flashcards', flip: 'Flip', front: 'Front', back: 'Back', prev: 'Previous', next: 'Next' },
        poll: { title: 'Poll', vote: 'Vote', change: 'Change vote', voters: '%{smart_count} vote |||| %{smart_count} votes', error: 'Your vote could not be saved.' },
        file: { download: 'Download file' },
        pdf: { title: 'PDF document' },
        completion: {
            button: 'Complete lesson',
            progress: '%{done} of %{total} exercises done',
            score: 'Score %{score}%',
            missing: 'Please complete the remaining exercise first. |||| Please complete the remaining %{smart_count} exercises first.',
            belowMin: 'You reached %{score}%, %{min}% is required. Try the exercises again.',
        },
    },
    lessons: {
        title: 'Lessons',
        loading: 'Loading lessons...',
        loadError: 'Error loading lessons',
        loadCourseError: 'Error loading course',
        newLesson: 'New Lesson',
        convert: {
            button: 'Create v2 copy',
            title: 'Move “%{title}” to the block format',
            intro: 'An inactive copy is created in the v2 authoring tool; the classic course stays as it is. The table shows in advance which lessons convert cleanly and where rework is needed.',
            summary: '%{total} lessons: %{converted} converted, %{partial} partial, %{manual} need manual rework',
            lesson: 'Lesson',
            sourceType: 'Type (classic)',
            blocks: 'Blocks',
            status: 'Status',
            statusLabel: { converted: 'Converted', partial: 'Partial', manual: 'Manual' },
            create: 'Create copy',
            done: 'Copy “%{title}” created – review it in the builder, then activate it.',
            error: 'The copy could not be created.',
            previewError: 'The conversion report could not be loaded.',
        },
        editLesson: 'Edit Lesson',
        createFirst: 'Create First Lesson',
        fromLibrary: 'From Library',
        noLessons: 'No lessons yet',
        lessonsFor: 'Lessons: %{title}',
        backToCourses: 'Back to Courses',
        editContent: 'Edit Content',
        mandatory: 'Mandatory',
        minScore: 'Min. %{score}%',
        updateSuccess: 'Lesson successfully updated',
        createSuccess: 'Lesson successfully created',
        deleteSuccess: 'Lesson successfully deleted',
        saveError: 'Error saving lesson',
        deleteError: 'Error deleting lesson',
        confirmDelete: 'Do you really want to permanently delete this lesson?\n\nParticipant progress data will be automatically adjusted.',
        preview: 'Preview',
        learningContent: {
            label: 'Learning content (optional)',
            helper: 'This formatted text is shown above the quiz in the player.',
        },
        types: {
            video: 'Video',
            document: 'Document',
            infoText: 'Info Text',
            multipleChoice: 'Multiple Choice',
            fillInBlank: 'Fill in the Blank',
            freeText: 'Free Text',
            dragDrop: 'Drag & Drop',
            matching: 'Matching',
            sorting: 'Sorting',
            hotspot: 'Hotspot',
            timeline: 'Timeline',
            scorm: 'SCORM',
            h5p: 'H5P',
            xapi: 'xAPI',
        },
        form: {
            title: 'Title',
            type: 'Type',
            description: 'Description',
            estimatedDuration: 'Estimated Duration (minutes)',
            minScore: 'Minimum Score (%)',
            minScoreHelp: 'Percentage required to pass',
            isMandatory: 'Mandatory Lesson',
            active: 'Active',
            enablePeerReview: 'Enable Peer Review',
            peerReviewInfo: 'When enabled, participants must submit their answer and will receive feedback from other course participants.',
            minPeerReviews: 'Minimum Reviews',
            minPeerReviewsHelp: 'Number of reviews each submission must receive (1-10)',
            peerReviewCriteria: 'Review Criteria',
            criterionName: 'Criterion',
            criterionDescription: 'Description',
            maxPoints: 'Max Points',
            addCriterion: 'Add Criterion',
            aiTutor: 'AI Learning Assistant',
            aiTutorInherit: 'Inherit from Course',
            aiTutorEnabled: 'Enabled',
            aiTutorDisabled: 'Disabled',
        },
        peerReview: 'Peer Review',
    },
    courseRating: {
        title: 'Rate Course',
        editTitle: 'Edit Rating',
        rateButton: 'Rate',
        editButton: 'Edit Rating',
        yourRating: 'Your Rating',
        comment: 'Comment (optional)',
        commentPlaceholder: 'What did you like about this course or what could be improved?',
        submitSuccess: 'Rating successfully saved',
        updateSuccess: 'Rating successfully updated',
        deleteSuccess: 'Rating successfully deleted',
        noRatings: 'No ratings yet',
        ratings: '%{count} ratings',
        averageRating: 'Average',
        labels: {
            terrible: 'Terrible',
            poor: 'Poor',
            ok: 'OK',
            good: 'Good',
            excellent: 'Excellent',
        },
        errors: {
            ratingRequired: 'Please select a rating',
            saveFailed: 'Error saving rating',
            deleteFailed: 'Error deleting rating',
        },
    },
    prerequisites: {
        title: 'Prerequisites',
        noPrerequisites: 'No prerequisites',
        completed: 'Completed',
        required: 'Required',
        recommended: 'Recommended',
        hard: 'Required',
        soft: 'Recommended',
        clickToView: 'Click to view',
        status: {
            noRequired: 'No prerequisites',
            allMet: 'All met',
            allMetTooltip: 'You have completed all prerequisites',
            blocked: '%{count} required not met',
            blockedTooltip: 'You must first complete: %{courses}',
            recommended: '%{count} recommended',
            warningTooltip: 'Recommended courses: %{courses}',
        },
        warningDialog: {
            title: 'Recommended Prerequisites',
            message: 'The following courses are recommended for "%{course}" but you haven\'t completed them yet.',
            recommendedCourses: 'Recommended courses:',
            proceedAnyway: 'You can still proceed, but we recommend completing these courses first.',
            goBack: 'Go Back',
            proceedButton: 'Enroll Anyway',
        },
        blockDialog: {
            title: 'Prerequisites Not Met',
            message: 'You cannot enroll in "%{course}" because you haven\'t completed the required prerequisites.',
            requiredCourses: 'Required courses:',
            completeFirst: 'Please complete these courses first to enroll.',
        },
    },
    gamification: {
        achievements: 'My Achievements',
        badgesTitle: 'Badges',
        streakTitle: 'Learning Series',
        leaderboardTitle: 'Leaderboard',
        fullLeaderboard: 'Full Leaderboard',
        earned: 'Earned',
        available: 'Available',
        noBadgesYet: 'You haven\'t earned any badges yet. Complete courses to earn badges!',
        allBadgesEarned: 'Congratulations! You\'ve earned all available badges.',
        days: 'days',
        currentStreak: 'Current series',
        longestStreak: 'Longest series',
        rank: 'Rank',
        streakAtRisk: 'Your series is at risk! Learn something today.',
        streakAtRiskMessage: 'Learn today to keep your series!',
        streakTooltip: '%{days} day learning series',
        badgeEarned: 'Badge Earned!',
        awesome: 'Awesome!',
        congratulations: 'Congratulations!',
        leaderboard: {
            rank: 'Rank',
            user: 'User',
            courses: 'Courses',
            badges: 'Badges',
            streakDays: 'Series Days',
            byCourses: 'By Courses',
            byBadges: 'By Badges',
            byStreak: 'By Series',
            you: 'You',
            yourPosition: 'Your position',
        },
    },
    learningPaths: {
        title: 'Learning Paths',
        myPaths: 'My Learning Paths',
        explore: 'Explore Learning Paths',
        courses: 'Courses',
        search: 'Search learning paths...',
        difficulty: 'Difficulty',
        allDifficulties: 'All',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        noPathsFound: 'No learning paths found',
        noEnrollments: 'No active learning paths',
        exploreDescription: 'Discover learning paths and start your journey',
        progress: 'Progress',
        yourProgress: 'Your progress',
        enroll: 'Enroll',
        enrollNow: 'Enroll Now',
        enrollSuccess: 'Successfully enrolled!',
        continue: 'Continue',
        viewCertificate: 'View',
        start: 'Start',
        completed: 'Completed',
        completedOn: 'Completed on',
        courseList: 'Course Overview',
        required: 'Required',
        optional: 'Optional',
        status: {
            enrolled: 'Enrolled',
            inProgress: 'In Progress',
            completed: 'Completed',
        },
        personal: 'Personal',
        pathCertificateHint: 'This learning path issues one certificate once all courses are completed – the individual courses issue none.',
        ai: {
            button: 'Create a learning path with AI',
            pageHint: 'Tell the AI what you want to learn – it puts together a fitting sequence of courses.',
            title: 'Create a learning path with AI',
            intro: 'Describe what you want to learn. The AI picks matching courses from the catalogue and orders them sensibly – you can adjust the draft afterwards.',
            topic: 'Topic',
            goal: 'Goal (optional)',
            level: 'Your current level',
            preview: 'Create draft',
            previewError: 'The draft could not be created.',
            reviewHint: 'Adjust the title, remove courses – then create.',
            pathTitle: 'Learning path title',
            removeStep: 'Remove %{title}',
            estimate: '%{steps} courses, approx. %{hours} hours',
            companyPath: 'Create as company path (inactive, for review in the management view)',
            pathCertificate: 'One certificate for the whole path instead of per course',
            back: 'Back',
            create: 'Create learning path',
            created: 'Learning path “%{title}” created.',
            createError: 'The learning path could not be created.',
        },
    },
    common: {
        back: 'Back',
        viewAll: 'View all',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
        delete: 'Delete',
    },
    recommendations: {
        title: 'Recommended for You',
        aiBadge: 'AI',
        aiHint: 'Picked for you by the AI – with a reason.',
        aiPending: 'The AI is putting together personal recommendations …',
        similarCourses: 'Similar Courses',
        enroll: 'Enroll',
        noRecommendations: 'No recommendations available',
        reasons: {
            sameCatalog: 'From your preferred catalog',
            nextDifficulty: 'Next difficulty level',
            sameDifficulty: 'Matching difficulty level',
            matchingTags: 'Similar topics',
            prerequisitesMet: 'Prerequisites met',
            popular: 'Popular with other learners',
            beginnerFriendly: 'Great for beginners',
        },
    },
    notifications: {
        title: 'Notifications',
        noNotifications: 'No notifications',
        markAllRead: 'Mark all read',
        justNow: 'Just now',
        minutesAgo: '%{count} min. ago',
        hoursAgo: '%{count} hr. ago',
        daysAgo: '%{count} days ago',
        types: {
            course_completed: 'Course completed',
            certificate_earned: 'Certificate earned',
            badge_earned: 'Badge earned',
            learning_path_completed: 'Learning path completed',
            streak_milestone: 'Series milestone',
            system: 'System message',
        },
    },
    emptyStates: {
        noCourses: {
            title: 'No courses found',
            description: 'There are no courses available yet. Check back later!',
            action: 'Browse course catalogs',
        },
        noBadges: {
            title: 'No badges yet',
            description: 'Complete courses and reach milestones to earn badges!',
        },
        noLearningPaths: {
            title: 'No learning paths',
            description: "You haven't enrolled in any learning paths yet.",
            action: 'Explore learning paths',
        },
        noRecommendations: {
            title: 'No recommendations',
            description: 'Complete more courses to get personalized recommendations.',
        },
        noEnrollments: {
            title: 'No courses yet',
            description: "You haven't enrolled in any courses yet. Explore our course catalog!",
            action: 'Discover courses',
        },
        noSearchResults: {
            title: 'No results',
            description: 'Try different search terms.',
            descriptionWithTerm: 'No results found for "%{term}". Try different search terms.',
        },
    },
    bookmarks: {
        title: 'My Bookmarks',
        add: 'Add bookmark',
        remove: 'Remove bookmark',
        noBookmarks: 'No bookmarks yet. Save interesting courses for later!',
        errorLoading: 'Error loading bookmarks',
        savedOn: 'Saved on',
        editNote: 'Edit note',
        noteLabel: 'Note',
        notePlaceholder: 'Why do you want to save this course?',
    },
    progress: {
        weeklyTitle: 'This Week',
        errorLoading: 'Error loading progress',
        lessonsCompleted: 'Lessons',
        coursesCompleted: 'Courses',
        activeDays: 'Active Days',
        dailyActivity: 'Daily Activity',
        lessons: 'lessons',
        overallProgress: 'Overall Progress',
        coursesLabel: 'courses',
        inProgress: 'In Progress',
        complete: 'complete',
        days: {
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat',
            sun: 'Sun',
        },
    },
    notes: {
        notes: 'Notes',
        add: 'Add',
        addNote: 'Add Note',
        newNote: 'New Note',
        editNote: 'Edit Note',
        edit: 'Edit',
        delete: 'Delete',
        title: 'Title',
        titlePlaceholder: 'Optional title...',
        content: 'Content',
        contentPlaceholder: 'Write your note here...',
        color: 'Color',
        privateNote: 'Private Note',
        private: 'Private',
        public: 'Public',
        untitled: 'Untitled',
        noNotes: 'No notes yet',
        noLessonNotes: 'No notes for this lesson',
        createFirst: 'Create your first note',
        createFirstNote: 'Create your first note in a course',
        currentLesson: 'Current Lesson',
        otherCourseNotes: 'Notes from other lessons',
        errorLoading: 'Error loading notes',
        loadError: 'Error loading notes',
        deleteConfirmTitle: 'Delete Note?',
        deleteConfirmMessage: 'Are you sure you want to delete this note?',
        // Overview page
        myNotes: 'My Notes',
        overviewDescription: 'All your notes from all courses in one place.',
        search: 'Search notes...',
        sort: 'Sort',
        filter: 'Filter',
        sortByDate: 'By Date',
        sortByTitle: 'By Title',
        sortByCourse: 'By Course',
        filterAll: 'All Notes',
        filterWithLesson: 'With Lesson',
        filterCourseOnly: 'Course Notes Only',
        totalNotes: '%{count} notes',
        totalCourses: '%{count} courses',
        notesCount: '%{count} notes',
        notesLabel: 'Notes',
        coursesLabel: 'Courses',
        noSearchResults: 'No notes found',
        tryDifferentSearch: 'Try a different search term',
        goToCourse: 'Go to Course',
        courseUnavailable: 'Course no longer available',
        exportPdf: 'Download as PDF',
        exportPdfShort: 'PDF',
    },
    search: {
        title: 'Search',
        placeholder: 'Search courses, wiki, learning paths...',
        resultsFor: 'Results for "%{query}"',
        results: 'results',
        noResults: 'No results found',
        tryDifferentTerms: 'Try different search terms',
        enterQuery: 'Enter a search term',
        errorSearch: 'Error during search',
        filters: 'Filters',
        contentType: 'Content Type',
        difficultyLabel: 'Difficulty',
        allDifficulties: 'All Difficulties',
        fromCourse: 'From course',
        types: {
            course: 'Course',
            lesson: 'Lesson',
            wiki: 'Wiki Article',
            learningPath: 'Learning Path',
        },
        difficulty: {
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
        },
    },
    export: {
        button: 'Export',
        dialog: {
            title: 'Export Data',
        },
        forCourse: 'For Course',
        general: 'General Exports',
        success: 'Export downloaded successfully!',
        'learning-history': {
            label: 'Learning History',
            description: 'Complete overview of all courses and progress',
        },
        transcript: {
            label: 'Course Transcript',
            description: 'Detailed report about this course',
        },
        notes: {
            label: 'Notes',
            description: 'Your personal notes as PDF',
        },
        'progress-report': {
            label: 'Progress Report',
            description: 'CSV export with detailed progress data',
        },
    },
    analytics: {
        title: 'My Learning Statistics',
        errorLoading: 'Error loading analytics',
        totalCourses: 'Total Courses',
        completedCourses: 'Completed',
        inProgress: 'in progress',
        learningTime: 'Learning Time',
        achievements: 'Achievements',
        completionRate: 'Completion Rate',
        lessonsCompleted: 'Lessons Completed',
        learningTimePerDay: 'Learning Time per Day',
        recentCompletions: 'Recent Completions',
        noCompletions: 'No completions yet',
        progressSummary: 'Progress Summary',
        avgProgress: 'Average Progress',
        avgScore: 'Average Score',
        myCourses: 'My Courses',
        noCourses: 'No courses available',
        enrolled: 'Enrolled',
        time: 'Time',
        activityOverview: 'Activity Overview',
        enrollmentTrend: 'Enrollments',
        completionTrend: 'Course Completions',
        inLast: 'In the last',
        days: 'days',
        noCourseData: 'No course data available',
        course: 'Course',
        participants: 'Participants',
        period: {
            week: '7 Days',
            month: '30 Days',
            quarter: '90 Days',
        },
        tabs: {
            overview: 'Overview',
            courses: 'Courses',
            activity: 'Activity',
        },
        status: {
            completed: 'Completed',
            inProgress: 'In Progress',
            enrolled: 'Enrolled',
        },
        instructor: {
            title: 'Instructor Dashboard',
            subtitle: 'Overview of your course performance',
            errorLoading: 'Error loading instructor statistics',
            noCourses: 'You have not created any courses yet',
            createCourse: 'Create a course to see statistics',
            myCourses: 'My Courses',
            participants: 'Participants',
            enrollments: 'Enrollments',
            completions: 'Completions',
            completionRate: 'Completion Rate',
            avgProgress: 'Avg. Progress',
            avgProgressShort: 'Avg. Progress',
            avgScore: 'Avg. Score',
            courseOverview: 'Course Overview',
            course: 'Course',
            enrolled: 'Enrolled',
            completed: 'Completed',
            lessonDetails: 'Lesson Details',
            selectCourse: 'Select a course from the table',
            courseStatsError: 'Course statistics could not be loaded',
            lesson: 'Lesson',
            attempts: 'Attempts',
            lessonCompletions: 'Completions',
            avgTime: 'Avg. Time',
        },
    },
    privacy: {
        title: 'Privacy',
        subtitle: 'Download a full copy of your data (Art. 15/20 GDPR) or delete your account (Art. 17 GDPR).',
        exportButton: 'Download my data (PDF)',
        exportButtonJson: 'As JSON for other providers',
        exportSuccess: 'Your data export has been downloaded.',
        exportError: 'Export failed. Please try again.',
        deleteButton: 'Delete account',
        deleteTitle: 'Request deletion of your account?',
        deleteWarning: 'Your company administrator receives your request and decides within one month. Once approved, your account is anonymised and permanently deleted after the retention period. If nobody decides by then, it is deleted automatically. Until a decision is made you can keep signing in and withdraw the request.',
        deleteConfirmButton: 'Request deletion',
        deleteConfirmLabel: 'Type "LÖSCHEN" to confirm',
        deleteConfirmWord: 'LÖSCHEN',
        deleteSuccess: 'Your deletion request has been received. Your company administrator will decide by %{dueAt}.',
        pendingTitle: 'Deletion requested',
        pendingText: 'On %{requestedAt} you requested to delete your account. Your company administrator will decide by %{dueAt}.',
        withdrawButton: 'Withdraw request',
        withdrawSuccess: 'Your deletion request has been withdrawn.',
        cancel: 'Cancel',
    },
    aiGrading: {
        disclaimer: 'Your answer will be pre-graded by an AI system. Please do not enter sensitive personal information. You always have the right to a review by your trainer.',
        attribution: 'AI-assisted grading — contact your trainer if you disagree.',
        model: 'Model',
        reviewPending: 'This grading will be reviewed by an authorised person and only counts after approval.',
        reviewPendingLesson: 'Your answers have been submitted. The AI pre-grading will be reviewed by an authorised person — the lesson completes automatically after approval.',
    },
    aiReview: {
        title: 'Review AI gradings',
        subtitle: 'AI pre-graded free-text answers of your learners. For courses with mandatory review, the grading only counts after your approval.',
        status: 'Status',
        all: 'All',
        minScore: 'Score from',
        maxScore: 'Score to',
        course: 'Course / lesson',
        answer: 'Answer',
        score: 'AI score',
        statusCol: 'Status',
        date: 'Submitted',
        actions: 'Actions',
        approve: 'Approve',
        override: 'Override',
        overrideTitle: 'Override grading',
        overrideHint: 'AI suggestion',
        newScore: 'New score',
        newFeedback: 'Feedback for the learner',
        originalAi: 'AI original',
        cancel: 'Cancel',
        save: 'Save',
        approved: 'Grading approved.',
        approvedCompleted: 'Approved — lesson has been completed.',
        overridden: 'Grading overridden.',
        empty: 'No AI gradings for the current filter.',
    },
    tutor: {
        title: 'AI Learning Assistant',
        aiLabel: 'AI',
        disclaimerTitle: 'You are chatting with an AI',
        disclaimerBody: 'The learning assistant is an AI system. Answers can be inaccurate or incomplete — do not rely on it alone for important questions and ask your trainer when in doubt. Your conversations are private, processed on our own servers, and you can delete them at any time. Please do not enter sensitive personal information.',
        disclaimerAccept: 'Got it',
        newConversation: 'New Conversation',
        history: 'History',
        noConversations: 'No previous conversations',
        welcomeTitle: 'Hello! I am your learning assistant.',
        welcomeWithLesson: 'Ask me questions about the lesson "%{lesson}"',
        welcomeGeneral: 'Ask me a question about the course content.',
        inputPlaceholder: 'Ask a question...',
        inputWithLesson: 'Question about "%{lesson}"...',
        quickHelpLabel: 'Quick Help',
        quickHelp: {
            explain: 'Simplify',
            explainTooltip: 'Explain this content more simply',
            example: 'Example',
            exampleTooltip: 'Show me an example',
            quiz: 'Test Me',
            quizTooltip: 'Ask me a question to test my understanding',
            summary: 'Summary',
            summaryTooltip: 'Summarize the content',
        },
        error: 'Error with request',
        loadError: 'Error loading',
    },
    learningGroups: {
        title: 'Learning Groups',
        myGroups: 'My Learning Groups',
        explore: 'Explore Learning Groups',
        createGroup: 'Create Learning Group',
        noGroups: 'No learning groups found',
        noMyGroups: 'You have not joined any learning groups yet',
        loading: 'Loading learning groups...',
        members: '%{count} members',
        maxMembers: 'Max. %{count} members',
        course: 'Course',
        public: 'Public',
        private: 'Invite only',
        join: 'Join',
        leave: 'Leave group',
        viewGroup: 'View Group',
        createdBy: 'Created by %{name}',
        joinSuccess: 'Successfully joined!',
        leaveSuccess: 'Left group',
        errorJoining: 'Error joining group',
        errorLeaving: 'Error leaving group',
        createDialog: {
            title: 'Create New Learning Group',
            name: 'Group Name',
            namePlaceholder: 'e.g. JavaScript Beginners',
            description: 'Description',
            descriptionPlaceholder: 'Describe what the group is about...',
            course: 'Course (optional)',
            selectCourse: 'Select course',
            noCourse: 'No course',
            maxMembers: 'Max. Members',
            maxMembersHelp: 'Leave empty for unlimited',
            isPublic: 'Public Group',
            isPublicHelp: 'Public groups can be joined by anyone',
        },
        detail: {
            members: 'Members',
            chat: 'Group Chat',
            admin: 'Admin',
            member: 'Member',
            noMessages: 'No messages yet. Start the conversation!',
            typePlaceholder: 'Type a message...',
            send: 'Send',
            you: 'You',
            errorLoading: 'Error loading group',
            errorSending: 'Error sending message',
        },
        tabs: {
            myGroups: 'My Learning Groups',
            explore: 'Explore',
        },
    },
    peerReview: {
        title: 'Peer Reviews',
        tabs: {
            toReview: 'To Review',
            mySubmissions: 'My Submissions (%{count})',
        },
        noPendingReviews: 'No pending reviews',
        noSubmissions: 'No submissions yet',
        status: {
            pending: 'Pending',
            inReview: 'In Review',
            completed: 'Completed',
        },
        assignedOn: 'Assigned on %{date}',
        submittedOn: 'Submitted on %{date}',
        reviewsReceived: '%{count} reviews',
        review: 'Review',
        viewFeedback: 'View Feedback',
        notFound: 'Assignment not found',
        submitTitle: 'Submit for Peer Review',
        submitDescription: 'Submit your work for the lesson "%{lesson}". Other participants will review your submission.',
        submissionLabel: 'Your Submission',
        submissionPlaceholder: 'Describe your solution or paste your text here...',
        submit: 'Submit',
        submitSuccess: 'Your submission has been submitted successfully and will be reviewed by other participants.',
        reviewTitle: 'Peer Review: %{lesson}',
        submissionToReview: 'Submission to Review',
        criteria: 'Review Criteria',
        yourReview: 'Your Review',
        ratingLabel: 'Overall Rating',
        feedbackLabel: 'Your Feedback',
        feedbackPlaceholder: 'Provide constructive feedback on the submission. What was good? What could be improved?',
        submitReview: 'Submit Review',
        resultTitle: 'Feedback for: %{lesson}',
        yourSubmission: 'Your Submission',
        averageRating: 'Average Rating',
        reviewCount: '%{count} reviews',
        receivedFeedback: 'Received Feedback',
        noFeedbackYet: 'No feedback received yet. Your submission is still being reviewed.',
        reviewer: 'Reviewer %{number}',
        reviewedOn: 'Reviewed on %{date}',
        attachFile: 'Attach file',
        fileHint: 'Optional: PDF, Word, Text, Images or ZIP (max. 10MB)',
        downloadAttachment: 'Download attachment',
        errors: {
            submissionRequired: 'Please enter your submission',
            ratingRequired: 'Please provide a rating',
            feedbackRequired: 'Please provide feedback',
            fileTooLarge: 'File too large (max. 10MB)',
        },
    },
    faq: {
        title: 'Help & FAQ',
        subtitle: 'Find answers to frequently asked questions',
        searchPlaceholder: 'Search FAQ...',
        allCategories: 'All',
        noResults: 'No FAQ entries found for your search.',
        noArticles: 'No FAQ entries available yet.',
        loadError: 'Error loading FAQ',
        contentError: 'Content could not be loaded.',
        noContent: 'No content available.',
        contactSupport: 'Question not found? Contact our support.',
    },
    products: {
        title: 'Products',
        searchPlaceholder: 'Search products...',
        filterType: 'Type',
        filterVisibility: 'Visibility',
        allTypes: 'All types',
        allVisibility: 'All',
        loadError: 'Error loading products',
        noProducts: 'No products available.',
        noSearchResults: 'No products found for your search.',
        featured: 'Featured',
        inactive: 'Inactive',
        noPrice: 'No price set',
        types: {
            course: 'Course',
            catalog: 'Catalog',
            bundle: 'Bundle',
            libraryItem: 'Library Item',
        },
        visibility: {
            public: 'Public',
            private: 'Private',
            unlisted: 'Unlisted',
        },
        pricing: {
            free: 'Free',
            oneTime: 'One-time payment',
            subscription: 'Subscription',
            perMonth: 'per month',
            perYear: 'per year',
        },
        actions: {
            view: 'View',
            edit: 'Edit',
            delete: 'Delete',
            addToCart: 'Add to Cart',
            enroll: 'Enroll Now',
        },
    },
    library: {
        title: 'Content Library',
        tabs: {
            myLibrary: 'My Library',
            operatorLibrary: 'Platform Library',
            company: 'My Library',
            operator: 'Platform Library',
        },
        search: 'Search library...',
        selectDialog: {
            titleCourse: 'Insert Course from Library',
            titleLesson: 'Insert Lesson from Library',
        },
        types: {
            course: 'Course',
            lesson: 'Lesson',
        },
        access: {
            copyAllowed: 'Copy allowed',
            referenceOnly: 'Reference only',
        },
        operatorContent: 'Platform content',
        usageCount: 'Used %{count} times',
        version: 'Version %{version}',
        searchPlaceholder: 'Search library...',
        filterType: 'Type',
        allTypes: 'All types',
        refresh: 'Refresh',
        loadError: 'Error loading library',
        noSearchResults: 'No results found for your search.',
        noItems: 'No items in the library yet.',
        insertSuccess: '"%{title}" successfully inserted',
        insertError: 'Error inserting from library',
        confirmDelete: 'Do you really want to delete "%{title}" from the library?',
        deleteSuccess: 'Successfully deleted from library',
        deleteError: 'Error deleting',
        actions: {
            insert: 'Insert',
            edit: 'Edit',
            delete: 'Delete',
            share: 'Share',
        },
        saveDialog: {
            title: 'Save to Library',
            titleLabel: 'Title',
            descriptionLabel: 'Description',
            tagsLabel: 'Tags',
            tagsPlaceholder: 'Enter a tag...',
            tagsHelp: 'Press Enter to add a tag',
            operatorContent: 'Save as platform content',
            operatorContentHint: 'Platform content can be shared with tenants and is only visible to operators.',
            save: 'Save to Library',
            titleRequired: 'Title is required',
            success: 'Successfully saved to library',
            error: 'Error saving to library',
        },
        insertDialog: {
            title: 'Insert from Library',
            description: 'Choose how to insert the content:',
            copyNotAllowed: 'Only reference mode is available for this content.',
            copyOption: 'Create Copy',
            copyDescription: 'Creates an independent copy that you can edit freely.',
            referenceOption: 'Create Reference',
            referenceDescription: 'Stays linked to the original. You will be notified of updates.',
            confirm: 'Insert',
            courseCreated: 'Course "%{title}" successfully %{mode}',
            lessonCreated: 'Lesson "%{title}" successfully %{mode}',
            asCopy: 'created as copy',
            asReference: 'created as reference',
        },
        sharing: {
            title: 'Share Content',
            description: 'Select the tenants to share this content with.',
            noCompanies: 'No tenants available.',
            loadError: 'Error loading tenants.',
            saveSuccess: 'Sharing settings saved successfully.',
            saveError: 'Error saving sharing settings.',
            revokeSuccess: 'Access revoked successfully.',
            revokeError: 'Error revoking access.',
            revoke: 'Revoke access',
            accessType: 'Access type',
            readonly: 'Reference only (read-only)',
            copyAllowed: 'Copy allowed',
            expiresAt: 'Expiration date',
            expiresAtHelp: 'Leave empty for unlimited access',
        },
        updates: {
            title: 'Available Updates',
            description: '%{count} content item(s) have updates available from the library.',
            checking: 'Checking for updates...',
            apply: 'Apply Update',
            applySuccess: 'Update applied successfully.',
            applyError: 'Error applying update.',
            versionChange: 'Version %{from} → %{to}',
            noUpdates: 'All content is up to date.',
        },
    },
    cart: {
        title: 'Shopping Cart',
        empty: {
            title: 'Your cart is empty',
            description: 'Discover our products and add them to your cart.',
        },
        unknownProduct: 'Unknown product',
        subtotal: 'Subtotal',
        discount: 'Discount',
        tax: 'Tax',
        total: 'Total',
        actions: {
            checkout: 'Checkout',
            continueShopping: 'Continue Shopping',
            clear: 'Clear',
            remove: 'Remove',
        },
        messages: {
            itemAdded: 'Product added to cart',
            itemRemoved: 'Product removed from cart',
            cartCleared: 'Cart cleared',
            addError: 'Error adding to cart',
            removeError: 'Error removing from cart',
            updateError: 'Error updating cart',
            clearError: 'Error clearing cart',
        },
    },
    orders: {
        title: 'My Orders',
        loading: 'Loading orders...',
        noOrders: 'No orders found.',
        orderNumber: 'Order Number',
        orderDate: 'Order Date',
        items: 'Items',
        total: 'Total',
        status: {
            pending: 'Pending',
            paid: 'Paid',
            completed: 'Completed',
            cancelled: 'Cancelled',
            refunded: 'Refunded',
        },
        paymentStatus: {
            pending: 'Pending',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        actions: {
            view: 'View Details',
            cancel: 'Cancel',
            download: 'Download Invoice',
        },
        detail: {
            title: 'Order Details',
            customerInfo: 'Customer Information',
            billingAddress: 'Billing Address',
            orderItems: 'Order Items',
            paymentInfo: 'Payment Information',
        },
        messages: {
            cancelSuccess: 'Order cancelled successfully',
            cancelError: 'Error cancelling order',
        },
    },
    checkout: {
        title: 'Checkout',
        steps: {
            review: 'Review',
            customer: 'Customer',
            payment: 'Payment',
            confirmation: 'Confirmation',
        },
        customerForm: {
            title: 'Your Details',
            email: 'Email Address',
            name: 'Full Name',
            billingAddress: 'Billing Address',
            street: 'Street and Number',
            city: 'City',
            postalCode: 'Postal Code',
            country: 'Country',
        },
        summary: {
            title: 'Order Summary',
            subtotal: 'Subtotal',
            discount: 'Discount',
            tax: 'Tax',
            total: 'Total',
        },
        payment: {
            title: 'Payment Method',
            paypal: 'Pay with PayPal',
            processing: 'Processing payment...',
        },
        confirmation: {
            title: 'Order Confirmed!',
            thankYou: 'Thank you for your order!',
            orderNumber: 'Your order number: %{orderNumber}',
            emailSent: 'A confirmation email has been sent to %{email}.',
            viewOrders: 'My Orders',
            continueShopping: 'Continue Shopping',
        },
        errors: {
            validationFailed: 'Please fill in all required fields.',
            paymentFailed: 'Payment failed. Please try again.',
            orderCreationFailed: 'Error creating order.',
        },
    },
    // ------------------------------------------------------------------
    // Marketplace rework (docs/dev/marketplace-rework-plan.md, section 4):
    // empty namespaces created in T1 — later tranches only append keys.
    // ------------------------------------------------------------------
    /** T5 — seller dashboard, listings, statements */
    marketplaceSeller: {
        title: 'Seller dashboard',
        subtitle: 'Offer your own courses on the marketplace, track sales and review statements.',
        openMarketplace: 'To the marketplace',
        openDashboard: 'Open seller dashboard',
        dashboardHint: 'New listings, submission and the sales overview are in the seller dashboard.',
        nav: {
            overview: 'Overview',
            listings: 'My listings',
            statements: 'Statements',
            billing: 'Billing details and PayPal',
        },
        visibility: {
            title: 'Where to offer?',
            public: {
                label: 'Public',
                short: 'Public',
                hint: 'Public: all online:academy customers see the listing. Payment runs through PayPal, the platform fee is %{fee} %. New public listings are reviewed before they go live.',
            },
            group: {
                label: 'My company group only',
                short: 'Company group',
                hint: 'My company group only: only your %{count} group companies can see the listing: %{names}. No fee, no PayPal payment, no review; the listing is available immediately.',
                more: 'and %{count} more',
            },
        },
        groupPricing: {
            title: 'For my company group',
            introPublic: 'What do companies in your group pay? Outside companies always pay the list price.',
            introGroup: 'What do the companies in your group pay?',
            same: 'Same price as everyone else (payment via PayPal)',
            free: 'Free of charge',
            internal: 'Internal transfer price (debit notice, no PayPal payment)',
            priceGroup: 'Internal transfer price (net)',
            priceGroupHelp: 'Issued to the company as a debit notice, not a tax document.',
        },
        status: {
            draft: 'Draft',
            in_review: 'In review',
            published: 'Published',
            rejected: 'Rejected',
            withdrawn: 'Withdrawn',
        },
        editor: {
            titleNew: 'Offer a course on the marketplace',
            titleEdit: 'Edit listing',
            steps: { course: 'Course and texts', pricing: 'License models and prices', visibility: 'Where to offer' },
            stepOf: 'Step %{current} of %{total}',
            lockedHint: 'The listing is published: description and tags can be changed. To change prices, license models or visibility, withdraw it first and submit it again.',
            rejectedHint: 'The listing was rejected: %{reason}',
            course: 'Course',
            courses: 'Courses in this listing',
            coursesHelp: 'Several courses form a bundle: one listing, one price, one license per course. The first course is the primary course.',
            selectedCourses: 'Selected courses',
            primary: 'Primary',
            searchCourses: 'Search courses …',
            noCourseFound: 'No courses found.',
            alreadyOffered: 'already offered',
            moveEarlier: 'Move %{title} up',
            removeCourse: 'Remove %{title}',
            removeTag: 'Remove tag %{tag}',
            title: 'Listing title',
            titleHelp: 'Leave empty to use the course title.',
            titleHelpBundle: 'Required for several courses: the bundle name, e.g. "Soft skills package".',
            description: 'Description',
            tags: 'Tags',
            tagsHelp: 'Enter or comma adds a tag; Backspace removes the last one.',
            category: 'Category',
            noCategory: 'No category',
            pricesNetHint: 'All prices are net prices, plus statutory VAT.',
            feeHint: 'For public offers the platform fee of %{fee} % is deducted before payout.',
            models: {
                reference: 'Reference license',
                referenceHelp: 'Live link: the buyer uses your course, changes apply immediately.',
                copy: 'Copy license',
                copyHelp: 'The buyer receives their own copy that they can adapt.',
                seat: 'Seat license',
                seatHelp: 'Copy with a fixed number of participants, the price applies per seat.',
            },
            priceNet: 'Price (net)',
            priceSeat: 'Price per seat (net)',
            yourShare: 'Your share after platform fee: %{amount}',
            next: 'Next',
            save: 'Save',
            saveDraft: 'Save as draft',
            saveAndSubmit: 'Save and submit',
            saved: 'Listing saved.',
            submitted: 'Listing submitted.',
            errors: {
                course: 'Please select at least one course.',
                bundleTitle: 'A listing title is required when offering several courses.',
                noModel: 'Please offer at least one license model.',
                price: 'Please enter a price of 0 or more for each offered license model.',
                priceGroup: 'Please enter an internal transfer price greater than 0.',
                save: 'The listing could not be saved.',
            },
        },
        listings: {
            title: 'My listings',
            intro: 'Public offers are reviewed before publication. Group offers are visible immediately.',
            new: 'Offer a course',
            empty: 'You have no listings yet. Use "Offer a course" to create the first one.',
            loadError: 'The listings could not be loaded.',
            actionError: 'The action could not be completed.',
            edit: 'Edit',
            submit: 'Submit',
            withdraw: 'Withdraw',
            delete: 'Delete',
            submitted: 'Listing submitted for review.',
            published: 'Listing published.',
            withdrawn: 'Listing withdrawn.',
            deleted: 'Listing deleted.',
            col: { course: 'Course', visibility: 'Visibility', status: 'Status', prices: 'Prices (net)', sales: 'Sales', actions: 'Actions' },
            priceRef: 'Reference',
            priceCopy: 'Copy',
            priceSeat: 'Seat',
            rejectedReason: 'Rejected: %{reason}',
            inReviewHint: 'Under review. Editing is possible after withdrawing.',
            warnings: {
                billing_incomplete: 'Billing details incomplete.',
                paypal_not_connected: 'PayPal account not connected yet.',
            },
            confirmWithdrawTitle: 'Withdraw listing?',
            confirmWithdraw: '"%{title}" will no longer be visible on the marketplace. Existing licenses stay valid.',
            confirmDeleteTitle: 'Delete listing?',
            confirmDelete: '"%{title}" will be deleted permanently.',
        },
        overview: {
            loadError: 'The sales overview could not be loaded.',
            readinessTitle: 'Some details are still missing for paid public listings.',
            readinessAction: 'Complete now',
            missing: {
                billing_data: 'Billing details are incomplete.',
                bank_account: 'No bank account is on file.',
                paypal: 'The PayPal account is not connected yet.',
            },
            period: { label: 'Period', '30d': '30 days', '90d': '90 days', '365d': '12 months', all: 'All time' },
            groupFree: 'free (group)',
            internalCharges: 'Internal transfers to your company group: %{amount} across %{count} licenses. This is not part of revenue.',
            chartTitle: 'Revenue per month',
            series: { gross: 'Gross revenue', net: 'Your share' },
            recentSales: 'Recent sales',
            allStatements: 'All statements',
            noSales: 'No sales in this period yet.',
            reviews: {
                title: 'Reviews',
                summary: '%{count} reviews, average %{average}',
                empty: 'No reviews for your listings yet.',
                reply: 'Your reply',
            },
        },
        kpi: {
            gross: 'Gross revenue',
            grossHint: 'Public sales, net of VAT',
            sales: 'Sales',
            salesGroup: 'of which %{count} free within the group',
            currentNet: 'Current month',
            currentNetHint: 'Your share after platform fee',
            paidOut: 'Settled (year)',
            paidOutHint: 'Statements marked as paid',
        },
        sales: {
            date: 'Date',
            course: 'Course',
            buyer: 'Buyer',
            origin: 'Origin',
            license: 'License',
            net: 'Price (net)',
            fee: 'Fee',
            share: 'Your share',
            types: { reference: 'Reference', copy: 'Copy', seat_copy: 'Seats' },
        },
        statements: {
            title: 'Statements',
            intro: 'Monthly overview of revenue, platform fee and your share. The overview is not a tax document.',
            empty: 'There are no statements yet.',
            loadError: 'The statements could not be loaded.',
            period: 'Period',
            number: 'Number',
            gross: 'Revenue',
            fee: 'Fee',
            net: 'Your share',
            status: 'Status',
            statuses: { open: 'Open', paid: 'Paid', void: 'Void' },
        },
        billing: {
            loadError: 'The billing details could not be loaded.',
            synced: 'Billing details synchronised.',
            paypal: {
                title: 'PayPal account',
                status: {
                    not_started: 'Not connected',
                    pending: 'Connection under review',
                    completed: 'Connected',
                    revoked: 'Connection revoked',
                },
                explain: 'For paid public listings, connect your PayPal business account. Customers pay you directly, the platform fee is withheld automatically.',
                connectedText: 'Your PayPal account is connected and can receive payments.',
                connect: 'Connect with PayPal',
                notAvailable: 'Connecting with PayPal is not available yet.',
                error: 'The PayPal connection could not be started.',
                groupHint: 'Listings for your company group only do not need a PayPal account.',
            },
            profile: {
                title: 'Billing details',
                sync: 'Synchronise',
                incomplete: 'The details are incomplete. Invoices to your customers need an address and a tax number or VAT ID.',
                legalName: 'Company name',
                missing: 'missing',
                address: 'Address',
                taxNumber: 'Tax number',
                vatId: 'VAT ID',
                smallBusiness: 'Small business (§ 19 UStG)',
                email: 'Billing email',
                iban: 'IBAN',
                accountHolder: 'Account holder',
                none: 'No billing details on file yet.',
                editHint: 'The details come from the company data. Change them there, then choose "Synchronise".',
            },
        },
    },
    /** T6 — catalog, listing page, checkout, licenses */
    marketplaceBuyer: {
        bundle: {
            pill: 'Bundle · %{count} courses',
            licensePill: 'From bundle: %{title}',
            factCourses: '%{count} courses in the package',
            more: '+ %{count} more',
            includes: 'Included courses (%{count})',
            checkoutHint: 'The price covers the whole package. You receive a separate license for each course.',
            priceNote: 'The price covers all %{count} courses together.',
            alreadyLicensed: 'You already own a course from this bundle. A course that is already licensed cannot be purchased again, so the bundle cannot be bought.',
            licenseCount: '%{count} licenses',
        },
        title: 'Marketplace',
        subtitle: 'License courses from other online:academy customers and use them directly in your own portal.',
        netPayPalNote: 'Prices net of VAT · payment via PayPal',
        filter: {
            level: 'Level',
            allLevels: 'All levels',
            sort: 'Sort order',
            sortNew: 'Newest first',
            sortName: 'Name A–Z',
            sortPrice: 'Price ascending',
        },
        loadError: 'The marketplace could not be loaded.',
        readOnlyHint: 'Licensing, licenses and invoices are reserved for company admins. You can see the offers and prices.',
        search: 'Search offers',
        nav: {
            browse: 'Offers',
            licenses: 'My licenses',
            orders: 'Orders and invoices',
        },
        tabs: {
            ariaLabel: 'Marketplace area',
            public: 'Public marketplace',
            group: 'Offers from my company group',
        },
        scopeHint: {
            public: 'Offers from all online:academy customers. Payment runs through PayPal, prices are net plus VAT.',
            group: 'Offers from companies in your company group. Free or with an internal transfer price, no PayPal payment.',
        },
        empty: {
            public: 'There are currently no matching offers in the public marketplace.',
            group: 'Your company group currently has no matching offers.',
        },
        difficulty: {
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
        },
        card: {
            licensed: 'Licensed',
            lessons: '%{count} lessons',
            details: 'Details',
            license: 'License',
        },
        price: {
            free: 'Free',
            groupFree: 'Group price: free',
            groupInternal: 'Group price: internal',
            perSeat: 'per seat',
            net: 'net',
            reference: 'Reference',
            copy: 'Copy',
            seat: 'Seats',
        },
        licenseType: {
            reference: {
                label: 'Reference license',
                chip: 'Reference',
                hint: 'Live link to the provider course, changes appear automatically.',
            },
            copy: {
                label: 'Copy license',
                chip: 'Copy',
                hint: 'Independent copy in your catalog, you can adapt the course.',
            },
            seat_copy: {
                label: 'Seat license',
                chip: 'Seats',
                hint: 'Copy with a fixed number of participants, price per seat.',
            },
        },
        detail: {
            notFound: 'This offer does not exist or is not visible to you.',
            back: 'Back to the marketplace',
            highlights: 'Highlights',
            previewVideo: 'Watch preview video',
            lessons: 'Content: %{count} lessons',
            prices: 'Prices',
            netNote: 'All prices are net, plus statutory VAT.',
            own: 'This is your own offer. Manage it in the seller dashboard.',
            content: 'Content',
            tags: 'Keywords',
            collapseAll: 'Collapse all',
            expandAll: 'Expand all',
            toggleSection: 'Show or hide section: %{title}',
            toggleCourse: 'Show or hide course: %{title}',
            kind: {
                lesson: 'Lesson',
                test: 'Test',
            },
            minutes: '%{count} min.',
            hours: 'approx. %{value} h',
            factLessons: '%{count} lessons',
            factDuration: 'Learning time',
            chooseLicense: 'Choose license',
            sum: 'Total net',
            vatNote: 'net plus VAT · payment via PayPal',
            trustInstant: 'Available immediately after payment',
            trustInvoice: 'Invoice from the provider as PDF',
            sellerFallback: 'Provider',
            sellerInfo: 'Seller · %{smart_count} listing on the marketplace |||| Seller · %{smart_count} listings on the marketplace',
            sellerInvoice: 'Invoice issued directly by the provider',
            allOffers: 'All offers',
            licenseOptions: 'License type',
        },
        checkout: {
            title: 'License course',
            success: 'License acquired successfully!',
            error: 'The order could not be created.',
            captureError: 'The payment could not be completed.',
            processing: 'Processing...',
            toPayment: 'Continue to payment',
            getInternal: 'Get at group price',
            getFree: 'Get for free',
            origin: {
                public: 'Public marketplace offer: the provider is another company, payment runs through PayPal.',
                group: 'Offer from your company group: the group price applies to you, no PayPal payment follows.',
            },
            licenseType: 'License type',
            seats: 'Number of participant seats',
            seatsHint: 'Every participant who is enrolled and starts permanently occupies a seat. Seats of started participants are not released on unenrollment.',
            seatsTimes: '%{seats} seats × %{price} per seat',
            targetCatalog: 'Target catalog',
            targetCatalogHelp: 'The copy is placed in this catalog of your course management.',
            defaultCatalog: 'Licensed courses (default)',
            settlement: {
                paypal: 'Payment through PayPal. The price is net, VAT is added. You see the final amount in the next step.',
                free: 'Free: the license is active immediately, no payment and no invoice follow.',
                internal: 'Internal transfer price: your company receives a debit notice. No PayPal payment follows, the notice is not a tax document.',
            },
            paypalUnavailable: 'PayPal is currently unavailable. Please try again later.',
            sellerNoPaypal: 'The provider has not connected PayPal yet, purchase is currently not possible.',
            alreadyLicensed: 'You have already licensed this course.',
            orderCreated: 'Order %{number} created. Total %{total}. Pay now with PayPal.',
            taxBreakdown: 'Net %{net} plus VAT (%{rate} %) %{tax}.',
            cancelled: 'The payment was cancelled. You can try again.',
            paypalError: 'PayPal reported an error. Nothing was charged.',
            doneBody: {
                paypal: 'Thank you, the payment has arrived. Your license is active, find the invoice under Orders and invoices.',
                free: 'The license is active.',
                internal: 'The license is active. Your company receives a debit notice for it.',
            },
            close: 'Close',
            toLicenses: 'To my licenses',
            cancel: 'Cancel',
        },
        licenses: {
            title: 'Acquired licenses',
            intro: 'Your acquired licenses with seat usage and media copy status. Manage enrollments and settings under Licensed courses.',
            manage: 'Licensed courses',
            empty: 'You have not licensed any courses yet.',
            loadError: 'The licenses could not be loaded.',
            seats: 'Participant seats',
            seatsOf: '%{used} of %{max} used',
            seatsUnlimited: '%{used} used, unlimited',
            seatsFull: 'All seats are taken.',
            copyOf: 'Copy: %{title}',
            since: 'Acquired on %{date}',
            expires: 'expires on %{date}',
            revoked: 'Revoked: %{reason}',
            status: {
                pending: 'Pending',
                active: 'Active',
                suspended: 'Suspended',
                expired: 'Expired',
                revoked: 'Revoked',
            },
            media: {
                pending: { title: 'Media waiting to be copied', hint: 'Videos, H5P content and files are about to be copied to your tenant.' },
                running: { title: 'Media are being copied', hint: 'The course is already usable, media appear step by step.' },
                done: { title: 'Media fully copied', hint: 'All content is in your tenant.' },
                failed: { title: 'Media copy failed', hint: 'The course stays usable. Retry copies the missing media.' },
                retry: 'Retry',
                retryStarted: 'The media copy was restarted.',
                retryError: 'The media copy could not be restarted.',
            },
        },
        orders: {
            title: 'Orders',
            intro: 'All license orders, including free group offers.',
            invoicesIntro: 'Seller documents, available as PDF download.',
            empty: 'You have no marketplace orders yet.',
            loadError: 'The orders could not be loaded.',
            downloadError: 'The invoice could not be loaded.',
            date: 'Date',
            number: 'Order number',
            item: 'Course and license type',
            amount: 'Amount',
            settlement: 'Settlement',
            status: 'Status',
            settlements: {
                paypal: 'PayPal',
                free: 'Free',
                internal: 'Debit notice',
            },
            statuses: {
                pending: 'Open',
                paid: 'Paid',
                completed: 'Completed',
                cancelled: 'Cancelled',
                payment_failed: 'Payment failed',
                refunded: 'Refunded',
                partially_refunded: 'Partially refunded',
            },
            invoicesTitle: 'Invoices',
            invoicesUnavailable: 'Invoices are available here after a purchase. They cannot be loaded right now.',
            invoicesEmpty: 'There are no invoices yet. Free licenses do not create a document.',
            invoiceNumber: 'Invoice number',
            invoiceType: 'Document',
            issuer: 'Issuer',
            pdf: 'PDF',
            download: 'Download invoice %{number} as PDF',
            documentTypes: {
                invoice: 'Invoice',
                cancellation: 'Cancellation invoice',
                credit_note: 'Credit note',
                group_transfer: 'Debit notice (not a tax document)',
            },
        },
    },
    /** T7 — storefront (public sales page) */
    storefront: {
        menu: 'Storefront',
        public: {
            nav: { home: 'Home', catalog: 'Courses', cart: 'Cart' },
            hero: { cta: 'Browse courses' },
            featured: 'Featured courses',
            features: 'Why choose us',
            testimonials: 'What participants say',
            faq: 'Frequently asked questions',
            catalog: { title: 'Courses', empty: 'No courses are available right now.', viewAll: 'All courses' },
            product: {
                free: 'Free',
                vatIncluded: 'incl. statutory VAT',
                lifetime: 'Unlimited access',
                timeLimited: 'Access for %{days} days',
                addToCart: 'Add to cart',
                inCart: 'In cart',
                buyNow: 'Book now',
                back: 'Back to courses',
                notFound: 'This course is no longer available.',
            },
            cart: {
                title: 'Cart',
                empty: 'Your cart is empty.',
                remove: 'Remove',
                total: 'Total',
                toCheckout: 'Checkout',
            },
            checkout: {
                title: 'Order',
                account: 'Your account details',
                loggedIn: 'You are signed in and buy for your existing account.',
                guestDisabled: 'This provider only allows purchases when signed in.',
                login: 'Sign in',
                email: 'Email',
                firstName: 'First name',
                lastName: 'Last name',
                password: 'Password',
                passwordHelp: 'At least 12 characters. An account is created for your access.',
                billing: 'Billing address',
                street: 'Street and number',
                zip: 'Postcode',
                city: 'City',
                country: 'Country (code, e.g. DE)',
                vatId: 'VAT ID (optional, businesses only)',
                acceptTerms: 'I accept the terms and conditions and have read the privacy policy.',
                acceptImmediateAccess: 'I expressly agree to immediate access and acknowledge that my right of withdrawal expires.',
                submit: 'Place order with obligation to pay',
                submitFree: 'Enrol for free',
                summary: 'Your order',
                payPalTitle: 'Pay now with PayPal',
                payPalLoading: 'Loading PayPal …',
                payPalUnavailable: 'PayPal is currently unavailable. Please try again later.',
                processing: 'Processing your order …',
                errorGeneric: 'The order could not be completed. You have not been charged.',
                paymentFailed: 'The payment could not be completed.',
            },
            order: {
                title: 'Your order',
                thanks: 'Thank you for your order!',
                thanksBody: 'Your access is ready. You can now sign in and start learning.',
                pending: 'Your payment is still being confirmed by PayPal. You will get access as soon as it arrives.',
                failed: 'The payment failed. You have not been charged.',
                number: 'Order number',
                toLogin: 'Go to learning area',
                notFound: 'Order not found.',
                emailPrompt: 'Please enter the email address of your order to confirm.',
                show: 'Show',
            },
            footer: { terms: 'Terms', privacy: 'Privacy', poweredBy: 'Provided via online:academy' },
            notFound: 'This page does not exist.',
            loadError: 'The page could not be loaded.',
        },
        admin: {
            title: 'Storefront',
            intro: 'Your public sales page: show and sell courses without login. Prices are gross prices for consumers.',
            tabs: { settings: 'Settings', products: 'Products', embeds: 'Embed' },
            notEnabledFeature: 'The storefront is not enabled for your company.',
            publicLink: 'Public link',
            openStore: 'Open storefront',
            settings: {
                enabled: 'Publish storefront',
                enabledHelp: 'Until published, the page is not publicly reachable.',
                slug: 'Address (slug)',
                slugHelp: 'Lowercase letters, digits and hyphens only, 3–60 characters. The page lives at /store/<slug>.',
                displayName: 'Display name',
                heroTitle: 'Headline',
                heroSubtitle: 'Subtitle',
                heroDescription: 'Description',
                heroImageUrl: 'Hero image (URL, https://)',
                allowGuestCheckout: 'Allow purchases without signing in',
                allowFreeEnrollment: 'Allow free enrolment',
                termsUrl: 'Terms (URL)',
                privacyPolicyUrl: 'Privacy policy (URL)',
                seoTitle: 'Page title (SEO)',
                seoDescription: 'Meta description (SEO)',
                customCss: 'Custom CSS (optional)',
                features: 'Benefits',
                faq: 'FAQ',
                testimonials: 'Testimonials',
                add: 'Add',
                remove: 'Remove',
                featureTitle: 'Title',
                featureDescription: 'Description',
                question: 'Question',
                answer: 'Answer',
                quote: 'Quote',
                author: 'Name',
                role: 'Role',
                save: 'Save',
                saved: 'Storefront saved.',
                saveError: 'Saving failed.',
                loadError: 'The storefront settings could not be loaded.',
            },
            products: {
                help: 'Order, recommendation and visibility of courses in the storefront. Create new products under "Products".',
                empty: 'No products yet.',
                title: 'Product',
                price: 'Price (gross)',
                status: 'Visibility',
                featured: 'Featured',
                position: 'Position',
                up: 'Move up',
                down: 'Move down',
                statusPublished: 'Visible',
                statusDraft: 'Hidden',
                statusArchived: 'Archived',
                manage: 'Manage products',
                updateError: 'The change could not be saved.',
            },
        },
    },
    /** T8 — embed widget */
    embed: {
        title: 'Embeddable widgets',
        intro: 'Show courses from your storefront on your own website. Each widget has its own token and works only on the websites you list here. A click always leads to your storefront – payment happens there, not in the widget.',
        empty: 'No widgets created yet.',
        needsStorefront: 'Set up and enable your storefront on the Settings tab first.',
        loadError: 'The widgets could not be loaded.',
        create: 'Create widget',
        columns: { label: 'Label', type: 'Type', origins: 'Allowed websites', status: 'Status', lastUsed: 'Last used', actions: 'Actions' },
        never: 'never',
        noOrigins: 'No website allowed – the widget is blocked',
        status: { active: 'Active', revoked: 'Revoked' },
        types: {
            catalog: { label: 'Catalog', description: 'Grid of all published courses' },
            course_card: { label: 'Single course', description: 'One course card with price and link' },
            landing: { label: 'Featured band', description: 'Headline with featured courses' },
            buy_button: { label: 'Button with price', description: 'Compact button or badge for one course' },
        },
        themes: { auto: 'Automatic (light/dark)', light: 'Light', dark: 'Dark' },
        actions: { snippet: 'Embed', edit: 'Edit', revoke: 'Revoke' },
        form: {
            createTitle: 'Create widget',
            editTitle: 'Edit widget',
            label: 'Label',
            type: 'Type',
            typeFixed: 'The type cannot be changed after creation.',
            theme: 'Appearance',
            product: 'Course',
            productRequired: 'Please choose a course.',
            noProducts: 'There are no published products.',
            origins: 'Allowed websites (one per line)',
            originsHelp: 'Scheme, host and optional port only, e.g. https://www.example.com – no paths, no wildcards. Without an entry the widget is blocked.',
            save: 'Save',
            cancel: 'Cancel',
        },
        snippet: {
            title: 'Embed widget',
            intro: 'Paste this code into your website. The website must be listed under Allowed websites.',
            mode: 'Embedding mode',
            modeScript: 'Script (directly in the page)',
            modeIframe: 'iframe (isolated, automatic height)',
            code: 'Code to paste',
            copy: 'Copy',
            copied: 'Code copied.',
            copyFailed: 'Copying failed – please select the code manually.',
            preview: 'Preview',
            previewError: 'The preview could not be loaded.',
            previewTitle: 'Widget preview',
            close: 'Close',
            revealError: 'The token could not be retrieved.',
        },
        revoke: {
            title: 'Revoke widget?',
            text: 'The widget "%{label}" will immediately stop showing anything on your website. This cannot be undone.',
            confirm: 'Revoke',
            done: 'Widget revoked.',
        },
        saved: 'Widget saved.',
        error: 'That did not work.',
    },
    /** T4 — billing profile, invoices, platform fee statements */
    billing: {},
    /** T9 — operator: moderation, refunds, webhook events, DATEV */
    /** Marketplace — operator view (T9): moderation, orders/refunds, settlement, webhook events, DATEV, reviews */
    marketplaceOperator: {
        title: 'Marketplace operations',
        intro: 'Approve listings, refund orders, run settlements and check payment events.',
        nav: {
            moderation: 'Moderation',
            orders: 'Orders',
            settlements: 'Settlement',
            events: 'Payment events',
            datev: 'DATEV export',
            reviews: 'Reviews',
        },
        common: {
            loadError: 'The data could not be loaded.',
            actionError: 'The action failed.',
            cancel: 'Cancel',
            reload: 'Reload',
            all: 'All',
            seller: 'Seller',
            buyer: 'Buyer',
            companyFallback: 'Tenant %{id}',
        },
        moderation: {
            title: 'Listings in review',
            intro: 'Public listings only appear in the marketplace after your approval. Group listings are not moderated.',
            empty: 'No listings in this view.',
            pending: '%{count} listing(s) waiting for review',
            filter: { in_review: 'In review', rejected: 'Rejected', published: 'Published', all: 'All' },
            submitted: 'Submitted on %{date}',
            free: 'Free',
            preview: 'Preview',
            approve: 'Approve',
            reject: 'Reject',
            approved: 'Listing approved. The seller has been notified.',
            rejected: 'Listing rejected. The seller has been notified.',
            rejectTitle: 'Reject listing',
            rejectIntro: 'The reason is sent to the seller as a notification and by email.',
            rejectReason: 'Reason',
            rejectRequired: 'Please enter a reason.',
            rejectConfirm: 'Reject',
            gateTitle: 'Approval not possible yet',
            gateIntro: 'Paid public listings need complete invoicing details and a connected PayPal account of the seller.',
            gate: {
                billing_incomplete: 'The seller’s invoicing details are incomplete.',
                paypal_not_connected: 'The seller’s PayPal account is not connected.',
            },
            blocked: 'Approval not possible: the seller’s prerequisites are missing.',
            previewTitle: 'Listing preview',
            fields: {
                seller: 'Seller',
                category: 'Category',
                courses: 'Courses in the bundle (%{count})',
                course: 'Course',
                difficulty: 'Difficulty',
                lessons: 'Lessons (%{count})',
                highlights: 'Highlights',
                tags: 'Tags',
                video: 'Preview video',
                prices: 'Prices (net)',
                fee: 'Platform fee',
                reference: 'Reference license',
                copy: 'Copy license',
                seat: 'Seat license per seat',
                rejectionReason: 'Previous rejection',
            },
        },
        orders: {
            title: 'Orders',
            intro: 'All marketplace and storefront orders paid via PayPal.',
            search: 'Order number, email or UUID',
            statusFilter: 'Status',
            channelFilter: 'Channel',
            channel: { marketplace: 'Marketplace', storefront: 'Storefront' },
            statuses: {
                pending: 'Pending',
                paid: 'Paid',
                completed: 'Completed',
                cancelled: 'Cancelled',
                payment_failed: 'Payment failed',
                refunded: 'Refunded',
                partially_refunded: 'Partially refunded',
            },
            empty: 'No orders found.',
            columns: { number: 'Order', date: 'Date', channel: 'Channel', parties: 'Seller / buyer', total: 'Amount', refunded: 'Refunded', status: 'Status', actions: 'Action' },
            refund: 'Refund',
            refundTitle: 'Refund order %{number}',
            refundIntro: 'The refund is made via PayPal on behalf of the seller; the platform fee is returned proportionally. A full refund removes the buyer’s access.',
            refundFull: 'Refund the full remaining amount (%{amount})',
            refundPartial: 'Refund a partial amount',
            refundAmount: 'Amount (gross)',
            refundAmountInvalid: 'Please enter an amount between 0.01 and %{max}.',
            refundReason: 'Reason (optional, sent to PayPal)',
            refundConfirm: 'Refund now',
            refunded: 'Refund booked.',
            notRefundable: 'Not refundable',
        },
        settlements: {
            title: 'Settlement',
            intro: 'The monthly run creates a statement per seller and, if commission is owed, the commission invoice. It can be repeated and never creates duplicates.',
            month: 'Month',
            run: 'Start settlement run',
            runDone: 'Settlement run %{month} finished: %{ok} statement(s), %{failed} with errors.',
            runEmpty: 'There were no billable sales in %{month}.',
            empty: 'No statements yet.',
            columns: { number: 'Number', company: 'Seller', period: 'Period', gross: 'Gross', refunds: 'Refunds', fee: 'Commission', net: 'Seller share', mode: 'Type', status: 'Status', actions: 'Action' },
            mode: { payout: 'Payout', commission: 'Commission due' },
            statuses: { open: 'Open', paid: 'Paid', void: 'Void' },
            markPaid: 'Mark as paid',
            markPaidTitle: 'Mark commission invoice %{number} as paid',
            markPaidIntro: 'For sellers in direct mode: confirm here that the commission payment has arrived (e.g. SEPA transfer).',
            reference: 'Payment reference (optional)',
            markPaidConfirm: 'Mark as paid',
            markedPaid: 'Marked as paid.',
        },
        events: {
            title: 'Payment events',
            intro: 'Received PayPal webhooks. Failed events can be processed again; processing is idempotent.',
            empty: 'No events.',
            filter: { all: 'All', failed: 'Failed', processed: 'Processed', received: 'Received', ignored: 'Ignored' },
            columns: { received: 'Received', type: 'Event', resource: 'Reference', status: 'Status', error: 'Error', actions: 'Action' },
            replay: 'Process again',
            replayed: 'Event processed again (%{result}).',
        },
        datev: {
            title: 'DATEV export',
            intro: 'Platform booking batch (commission invoices, fees) in DATEV format for your tax advisor. Every export is logged and can be downloaded again.',
            from: 'From',
            to: 'To',
            create: 'Create export',
            created: 'Export created with %{count} booking(s).',
            rangeInvalid: 'Please enter a valid period (To not before From).',
            history: 'Previous exports',
            empty: 'No exports yet.',
            columns: { created: 'Created', period: 'Period', scope: 'View', bookings: 'Bookings', file: 'File', actions: 'Action' },
            scope: { platform: 'Platform', seller: 'Seller' },
            download: 'Download',
        },
        reviews: {
            title: 'Reviews',
            intro: 'Reviews are published without prior moderation. You can hide inappropriate posts; hidden reviews no longer count towards the average.',
            empty: 'No reviews.',
            filter: { all: 'All', approved: 'Visible', hidden: 'Hidden' },
            hide: 'Hide',
            unhide: 'Show again',
            hidden: 'Hidden',
            visible: 'Visible',
            updated: 'Review updated.',
            reply: 'Seller reply',
        },
    },
    /** Marketplace — reviews (T9): display on the detail page, form on the license card */
    marketplaceReviews: {
        title: 'Reviews',
        count: '%{count} review(s)',
        noReviews: 'No reviews yet.',
        average: 'Average %{value} out of 5',
        stars: '%{count} out of 5 stars',
        starInput: '%{count} stars',
        mine: 'Your review',
        loadError: 'The reviews could not be loaded.',
        anonymous: 'A company',
        sellerReply: 'Reply from the seller',
        reply: 'Reply',
        editReply: 'Edit reply',
        replyLabel: 'Your reply',
        replySave: 'Save reply',
        replyRemove: 'Remove reply',
        replySaved: 'Reply saved.',
        replyError: 'The reply could not be saved.',
        write: 'Write a review',
        edit: 'Edit review',
        yourRating: 'Your rating: %{count} out of 5',
        dialogTitle: 'Rate course',
        dialogIntro: 'Your review is visible to all companies in the marketplace. One review is possible per license; you can change it later.',
        ratingLabel: 'Stars',
        ratingRequired: 'Please give 1 to 5 stars.',
        titleLabel: 'Headline (optional)',
        bodyLabel: 'Your experience (optional)',
        submit: 'Save review',
        saved: 'Thank you for your review.',
        error: 'The review could not be saved.',
        cancel: 'Cancel',
    },
    /** Platform settings (operator): issuer, DATEV, fees, jobs, PayPal, environment */
    platformSettings: {
        title: 'Platform settings',
        intro: 'Maintain the values that used to be set per environment in configuration files. A value set here takes precedence; an empty field uses the environment value (shown in grey inside the field).',
        loading: 'Loading settings',
        loadError: 'The settings could not be loaded.',
        save: 'Save',
        saved: 'Settings saved.',
        saveError: 'The settings could not be saved.',
        invalid: 'Please check the highlighted fields.',
        emptyHint: 'Empty fields use the environment value.',
        sourceDb: 'Set in the app',
        sourceEnv: 'From environment',
        tabs: {
            issuer: 'Issuer',
            datev: 'DATEV',
            fees: 'Fees',
            jobs: 'Jobs',
            paypal: 'PayPal',
            environment: 'Environment',
        },
        issuer: {
            fields: {
                name: 'Company name',
                legal_representative: 'Owner / legal representative',
                email: 'Invoice e-mail',
                street: 'Street and number',
                zip: 'Postal code',
                city: 'City',
                country: 'Country (code)',
                website: 'Website',
                vat_id: 'VAT ID',
                tax_number: 'Tax number',
                iban: 'IBAN',
                bic: 'BIC',
                register_court: 'Register court',
                commercial_register: 'Commercial register number',
                primary_color: 'Accent colour (#rrggbb)',
                footer: 'Invoice footer',
            },
            logo: 'Logo',
            logoUpload: 'Upload logo',
            logoRemove: 'Remove logo',
            logoHint: 'PNG, JPEG, WebP or SVG, 256 KB at most. The logo appears on commission invoices (PR-…).',
            logoType: 'Only PNG, JPEG, WebP or SVG are allowed.',
            logoSize: 'The logo is larger than 256 KB.',
            requirement: 'Commission invoices require a name, an address and either a VAT ID or a tax number. Without them the monthly settlement does not issue a commission invoice.',
        },
        datev: {
            consultant_number: 'Consultant number',
            client_number: 'Client number',
            chart_of_accounts: 'Chart of accounts',
            account_length: 'Account number length',
            fiscal_year_start_month: 'Start of the fiscal year (month)',
        },
        fees: {
            marketplace_fee_percent: 'Marketplace platform fee (%)',
            storefront_fee_percent: 'Storefront platform fee (%)',
            currency: 'Currency',
        },
        jobs: {
            intro: 'These jobs start automatically through the platform scheduler. An empty cron field uses the default schedule; times are in server time.',
            enabled: 'Active',
            disabled: 'Inactive',
            cron: 'Schedule (cron)',
            cronDefault: 'Default: %{cron}',
            lastRun: 'Last run',
            neverRun: 'Never run',
            status: {
                ok: 'Succeeded',
                failed: 'Failed',
                running: 'Running',
            },
        },
        paypal: {
            webhook_id: 'Webhook ID',
            env: { sandbox: 'Sandbox', live: 'Live' },
            credentialsOk: 'Credentials set',
            credentialsMissing: 'Credentials missing',
            credentialsHint: 'The PayPal client ID and secret must be set in the environment before a webhook can be created.',
            url: 'Webhook URL of this environment',
            check: 'Check webhook',
            register: 'Register webhook',
            created: 'Webhook created at PayPal and its ID saved.',
            exists: 'The webhook was already registered, the ID has been saved.',
            error: 'PayPal could not be reached.',
            registeredOk: 'Registered (ID %{id}) and identical to the stored ID.',
            registeredMismatch: 'Registered (ID %{id}), but the stored ID differs. Please run "Register webhook".',
            notRegistered: 'No webhook is registered at PayPal for this URL yet.',
            missingEvents: 'Missing events: %{events}',
        },
        environment: {
            intro: 'Credentials and keys stay in the environment and are never shown here, only whether they are set.',
            secrets: 'Credentials and keys',
            values: 'Operating parameters',
            set: 'Set',
            missing: 'Missing',
        },
    },
};
